/* eslint-disable */ 
<template>
<div class="order-form-wrapper">
<div class="order-head cleared">
            <div class="order-head__flex ft-lt cleared">
              <div class="header-main">
              <div class="hm-left">
                <div class="order-num ft-lt">
                                            Новый заказ
                                    </div>
                                    </div>

                                    <div class="hm-right">
                                     <button
    class="white small btn-save-back btn_split-hov btn"
    @click="saveFormAndCollapse"
   style="display:none;">
    Свернуть
  </button>
  <button
    class=" btn-close-order "
    @click="deleteForm"
  >
   
  </button>
  </div>
  </div>
                                            </div>
                    </div>
  <div class="m-box m-box__template-group-main mn-or-info">   
        <div id="order-common" class="collapse-section template-block" data-template-block-code="common">
        <div class="collapse-section__head">
            <div class="collapse-section__title">Основное</div>
            <div class="collapse-section__head-col">
                <div class="collapse-section__head-content"></div>
                <div class="section-error" v-if="error">
                    <div class="section-error__icon">
                        <svg class="svg-icon">
                            <use xlink:href="/build/icons.03e7bd82.svg#error_outlined"></use>
                        </svg>
                    </div>
                    <div class="section-error__text" v-if="!isFieldFilled">Не заполнено обязательное поле</div>
                </div>
                <div class="collapse-section__btn" @click="toggleSection">
                    <svg class="svg-icon">
                        <use :xlink:href="sectionExpanded ? '/build/icons.03e7bd82.svg#chevron_down' : '/build/icons.03e7bd82.svg#chevron_up'"></use>
                    </svg>
                </div>
            </div>
        </div>

        <div  class="collapse-section__body">
            <div class="bk">
                <!-- Страна -->
                <div id="country-text" class="input-group cleared" style="display:none;">
                    <label for="country">Страна</label>
                    <v-select :options="countries" v-model="formData.country" label="label" placeholder="Выберите страну"></v-select>
                </div>

                <!-- Тип заказа -->
                <div class="input-group cleared">
                    <label for="orderType" class="required">Тип заказа</label>
                    <v-select 
                        :options="orderTypes" 
                        v-model="formData.orderType" 
                        label="label" 
                        placeholder="- Укажите тип -" 
                        :class="{ 'is-invalid': errors.orderType, 'is-valid': formData.orderType }"
                        @input="validateField('orderType')"
                    ></v-select>
                    <span v-if="errors.orderType" class="error-message">✖</span>
                    <span v-else-if="formData.orderType" class="success-message">✔</span>
                </div>

                <!-- Менеджер -->
                <div class="input-group cleared">
                    <label for="manager">Менеджер</label>
                    <v-select :options="managers" v-model="formData.manager" label="label" placeholder="- Укажите менеджера -"></v-select>
                </div>

                <!-- Магазин -->
                    <div class="input-group cleared">
                        <label for="site" class="required">Магазин</label>
                        <v-select 
                            :options="sites" 
                            v-model="formData.site" 
                            label="label" 
                            placeholder="- Укажите магазин -" 
                            :class="{ 'is-invalid': errors.site, 'is-valid': formData.site }"
                            @input="validateField('site')"
                        ></v-select>
                        <span v-if="errors.site" class="error-message">✖</span>
                        <span v-else-if="formData.site" class="success-message">✔</span>
                    </div>
                <!-- Способ -->
                <div class="input-group cleared">
                    <label for="orderMethod">Способ</label>
                    <v-select :options="orderMethods" v-model="formData.orderMethod" label="label" placeholder="- Укажите способ оформления -"></v-select>
                </div>
            </div>
            </div>
        </div>


        <!-- Блок "Клиент" -->
        <div id="order-customer" class="collapse-section template-block" data-template-block-code="customer">
    <div class="collapse-section__head">
        <div class="collapse-section__title">Клиент</div>
        <div class="collapse-section__head-col">
            <div class="collapse-section__head-content"></div>
            <div class="section-error">
                <div class="section-error__icon">
                    <svg class="svg-icon">
                        <use xlink:href="/build/icons.03e7bd82.svg#error_outlined"></use>
                    </svg>
                </div>
                <div class="section-error__text section-error__text_usual">Ошибка в блоке</div>
                <div class="section-error__text section-error__text_require">Не заполнено обязательное поле</div>
            </div>
           
        </div>
    </div>
    <div class="collapse-section__body" >
        
            
                <div class="bk">
                    <div class="input-group cleared">
                        <label  for="lastName">Фамилия</label>
                        <input type="text" id="lastName" v-model="formData.lastName" class="input-field">
                    </div>
                    <div class="input-group cleared">
                        <label  for="email">Email</label>
                        <input type="email" id="email" v-model="formData.email" class="input-field">
                    </div>
                    <div class="input-group cleared">
                        <label class="required" for="firstName">Имя</label>
                        <input type="text" id="firstName" @input="validateField('firstName')" v-model="formData.firstName" :class="{ 'is-invalid': errors.firstName, 'is-valid': formData.firstName }" class="input-field" required>
                         <span v-if="errors.firstName" class="error-message">✖</span>
                        <span v-else-if="formData.firstName" class="success-message">✔</span>
                    </div>
                    <div class="input-group cleared" style="position:relative;">
                        <label  for="phone">Телефон</label>
                        <input type="text" id="phone" v-model="formData.phone" class="input-field">
                        <div v-if="formData.phone" @click="makeCall" class="call-button"></div>
                    </div>
                    <div class="input-group cleared">
                        <label  for="patronymic">Отчество</label>
                        <input type="text" id="patronymic" v-model="formData.patronymic" class="input-field">
                    </div>
                    <div class="input-group cleared">
                        <label  for="additionalPhone">Доп. телефон</label>
                        <input type="text" id="additionalPhone" v-model="formData.additionalPhone" class="input-field">
                    </div>
                    <div class="input-group cleared">
                        <label  for="email2">Email2</label>
                        <input type="email" id="email2" v-model="formData.email2" class="input-field">
                    </div>
                    <div class="input-group cleared">
                        <label  for="selectionLink">Ссылка на подбор</label>
                        <input type="text" id="selectionLink" v-model="formData.selectionLink" class="input-field">
                        <div class="auto_podbor" @click="openCarSelector"></div>


                    </div>
                    <!--<div class="input-group cleared">
                        <label  for="carBrand">Марка ТС</label>
                        <input type="text" id="carBrand" v-model="formData.carBrand" class="input-field">
                    </div>
                    <div class="input-group cleared">
                        <label  for="carModel">Модель ТС</label>
                        <input type="text" id="carModel" v-model="formData.carModel" class="input-field">
                    </div>
                    <div class="input-group cleared">
                        <label  for="carName">Название ТС</label>
                        <input type="text" id="carName" v-model="formData.carName" class="input-field">
                    </div>
                    <div class="input-group cleared">
                        <label  for="carYear">Год ТС</label>
                        <input type="text" id="carYear" v-model="formData.carYear" class="input-field">
                    </div>
                    <div class="input-group cleared">
                        <label  for="fuelType">Вид топлива</label>
                        <input type="text" id="fuelType" v-model="formData.fuelType" class="input-field">
                    </div>
                    <div class="input-group cleared">
                        <label  for="carBodyType">Тип корпуса в подборе ТС</label>
                        <input type="text" id="carBodyType" v-model="formData.carBodyType" class="input-field">
                    </div>-->
                    <div class="input-group cleared">
                        <label  for="wrongSelection">Неверный подбор на сайте</label>
                        <input type="checkbox" id="wrongSelection" v-model="formData.wrongSelection" class="input-field" value="1">
                    </div>
                    <div class="input-group cleared">
                        <label  for="seller">Продавец</label> 
                        <v-select :options="seller" v-model="formData.seller" label="label" placeholder="- Продавец -"></v-select>
                        
                    </div>
                </div>

                <div class="bk" data-order-section="customer">
                    <div class="bk-control cleared ml0">
                        <div class="red-tl fs10 ">Юридические реквизиты</div>
                    </div>
                    <div class="input-group cleared">
                        <label for="contractorType" class="required">Тип контрагента </label>
                        <v-select 
                            :options="contragentTypes" 
                            v-model="formData.contragentTypes" 
                            label="label" 
                            placeholder="--Выбрать тип контрагента--" 
                            :class="{ 'is-invalid': errors.contragentTypes, 'is-valid': formData.contragentTypes }"
                            @input="validateField('contragentTypes')"
                        ></v-select>
                        <span v-if="errors.contragentTypes" class="error-message">✖</span>
                        <span v-else-if="formData.contragentTypes" class="success-message">✔</span>
                    </div>
                  <div class="input-group cleared">
  <label for="tradeInAmount">Сумма за аккумулятор в зачет</label>
  <input type="text" id="tradeInAmount" v-model="formData.tradeInAmount" class="input-field">
</div>
                    <div class="input-group cleared">
                        <label  for="invoiceDate">Счет-фактура от</label>
                        

                        <date-picker 
                            v-model="formData.invoiceDate" 
                            lang="ru" 
                            :format="'DD.MM.YYYY'" 
                            placeholder="Выберите дату" 
                            input-class="input-field"
                        ></date-picker>
                    </div>





                    <div class="input-group cleared">
                        <label  for="batteryCapacity">Ёмкость аккумулятора в зачет</label>
                        <input type="text" id="batteryCapacity" v-model="formData.batteryCapacity" class="input-field">
                    </div>
                    <div class="input-group cleared">
                        <label  for="discountCard">Есть скидочная карта</label>
                        <input type="checkbox" id="discountCard" v-model="formData.discountCard" class="input-field" value="1">
                    </div>
                    <div class="input-group cleared">
                        <label  for="managerComments">Комментарии менеджера</label>
                        <textarea id="managerComments" v-model="formData.managerComments" class="input-field"></textarea>
                    </div>
                </div>
            
        
    </div>
</div>



<div id="order-list" class="collapse-section template-block" data-template-block-code="list">
    <div class="collapse-section__head">
        <div class="collapse-section__title">
            <div class="order-table__title">Состав заказа
                <!--<sup class="order-table__count" id="product-available-count">0</sup>-->
            </div>
        </div>
        <div class="collapse-section__head-col">
            <div class="collapse-section__head-content" style="margin-left: auto; display: flex">
                <div class="bk-btn">
                    <a id="add-order-product-btn" class="btn small white" @click="openModal">
                        Добавить товары<span class="icon-new"></span>
                    </a>
                </div>
            </div>
            
        </div>
    </div>
    <div class="collapse-section__body" >
        <div class="order-table-header" data-order-section="list">
            <div class="m-box order-products-table-box with-popups">
                <table class="modern-table order-products default modern-order-table ui-sortable nested-table" id="order-products-table">
                    <thead>
                        <tr>
                            <th class="order-products__counter-cell">№</th>
                            <th class="title order-products__image">Товар/услуга</th>
                            <th class="bord heading-th">&nbsp;</th>
                            <th class="properties-th bord nested-th">Свойства</th>
                            <th class="bord nested-th">Цена</th>
                            <th class="quantity nested-th_hide">Кол-во</th>
                            <th class="subtotal align-to-input">Стоимость</th>
                        </tr>
                    </thead>
                    <tbody v-for="(product, index) in products" :key="index" class="product-group order-products-tbody">
                        <tr>
                            <td>{{ index + 1 }}</td>
                            <td><div><img :src="product.jpg_url" alt="Фото товара" style="max-width:50px"/></div></td>
                            <td style="text-align:left;"><p>{{ product.name }}</p>
                            
                            <span class="acc-tovar" @click="openAnalogModal(product)">Сопутствующие товары</span>
                            </td>
                            <td></td>
                            <td @click="openPriceDropdown(product)" style="cursor: pointer;">
                            <div class="order-price__value">
    <span class="discounted-price">{{ product.displayPrice }} руб.</span>
    <span v-if="product.discountAmount || product.discountPercent" class="original-price">{{ product.originalPrice }} руб.</span>
</div>
                               
                            </td>
                            <td>
                                <div class="button_quantity">
                                    <button @click="decreaseQuantity(product)" class="qty-btn qty-btn-decrease">-</button>
                                    <input 
                                      type="number" 
                                      v-model.number="product.quantity" 
                                      @change="updateQuantity(product)" 
                                      class="min-input quantity"
                                      min="1"
                                    />
                                    <button @click="increaseQuantity(product)" class="qty-btn qty-btn-increase">+</button>
                                </div>
                            </td>
                            <td><span class="inline-tooltip__target js-subtotal-value">{{ product.total }}&nbsp;<span class="currency-symbol byn">руб.</span></span>
                            <div class="info-btn-group info-btn-group_product" @click="removeProduct(product.id)"><div class="info-btn js-order-product-delete-button"><div class="info-btn__switch info-btn__switch_trash"></div><div class="info-btn__tooltip">Удалить позицию из заказа</div></div></div>

                            </td>
                        </tr>
                    </tbody>
                </table>
                <!-- Выпадающее поле для редактирования цены -->
                <div v-if="priceDropdownVisible" class="order-price__dropdown" :style="{ top: dropdownPosition.top, left: dropdownPosition.left }">
                    <div class="order-price__main">
                        <label>
                            <span class="order-price__caption">Цена</span>
                            <div class="order-price__input-wrap">
                                <input v-model.number="priceInput" type="text" class="order-price__input" />
                                <span class="currency-symbol">руб.</span>
                            </div>
                        </label>
                    </div>
                    <div class="order-price__discount">
                        <p class="order-price__caption">Скидка</p>
                        <div class="order-price__controls">
                            <div class="order-price__input-wrap">
                                <input v-model.number="discountAmount" type="text" class="order-price__input" placeholder="0" />
                                <span class="currency-symbol">руб.</span>
                            </div>
                            <div class="order-price__input-wrap">
                                <input v-model.number="discountPercent" type="text" class="order-price__input" placeholder="0" />
                                <span>%</span>
                            </div>
                        </div>
                    </div>
                    <div class="order-price__controls">
                        <button @click="applyPriceChange" class="btn order-price__apply">Применить</button>
                        <button @click="closePriceDropdown" class="btn order-price__cancel">Отмена</button>
                    </div>
                </div>
                <div class="order-empty" v-if="products.length === 0">
                    <p>В заказе еще нет товаров или услуг,<br>добавьте их с помощью кнопки «Добавить» справа</p>
                </div>
            </div>
        </div>

        <div class="order-row">
            <div class="order-row__top">
                <p class="order-row__title">
                    Разовая скидка
                    
                </p>

                <div class="order-discount order-discount__inputs">
                    <!-- Поле ввода скидки в рублях -->
                    <div class="order-discount__input-wrap order-discount__input-wrap_rub">
                        <input 
                            type="number" 
                            v-model="oneTimeDiscountAmount" 
                            @input="updateTotalDiscount" 
                            class="order-discount__input order-disc-rub order-value-input" 
                            placeholder="0"
                        />
                        <span class="order-discount__currency"><span class="currency-symbol byn">руб.</span></span>
                    </div>

                    <!-- Поле ввода скидки в процентах -->
                    <div class="order-discount__input-wrap order-discount__input-wrap_percent">
                        <input 
                            type="number" 
                            v-model="oneTimeDiscountPercent" 
                            @input="updateTotalDiscount" 
                            class="order-discount__input order-disc-percent order-value-input" 
                            placeholder="0"
                        />
                        <span class="order-discount__currency">%</span>
                    </div>
                </div>
            </div>

            <div class="order-discount-errors patch-target" id="patch-order-discount-errors">
                <input type="hidden" id="intaro_crmbundle_ordertype_discountDividerFix" autocomplete="disabled" value="0">
            </div>
        </div>


        <div class="order-table-footer">

            <div class="order-table-footer__left patch-target"></div>

            <div class="order-table-footer__right patch-target">
                <ul class="order-table-footer__list order-table-footer__list_info">
                    <li class="order-table-footer__list-item">
                        <p class="order-table-footer__text order-table-footer__text_muted order-table-footer__text_full">Стоимость товаров</p> <p class="order-table-footer__text order-table-footer__text_price"> {{ totalPrice.toLocaleString() }} руб.</p>
                    </li>
                    <li class="order-table-footer__list-item">
                        <p class="order-table-footer__text order-table-footer__text_muted order-table-footer__text_full">Сумма скидок по заказу</p> <p class="order-table-footer__text order-table-footer__text_price"> {{ totalDiscount.toLocaleString() }} руб.</p>
                    </li>
                    <li class="order-table-footer__list-item" v-if="this.deliveryCost > 0">
                        <p class="order-table-footer__text order-table-footer__text_muted order-table-footer__text_full">Стоимость доставки</p> <p class="order-table-footer__text order-table-footer__text_price"> {{ this.deliveryCost }} руб.</p>
                    </li>
                    
                        
                    
                </ul>
                <p class="order-table-footer__total">Итого: <span> {{ grandTotal.toLocaleString() }} руб.</span></p>
            </div>
        </div>
    </div>
</div>
  <div class="list-box-two">
  <div class=" m-box__left-side">

  <div id="order-delivery" class="collapse-section template-block" data-template-block-code="delivery">
    <div class="collapse-section__head">
      <div class="collapse-section__title">
        Отгрузка и доставка
      </div>
      
    </div>

    <div class="collapse-section__body" >
      <div class="bk no-top-border" data-order-section="shipment">
        <div class="bk-control cleared">
          <div class="red-tl">Склад</div>
          <div class="sl-lk sl-lk_gorizontal">
            
          </div>
        </div>

        <!-- Поле выбора склада -->
        <div class="input-group cleared">
          <label class="label-common" for="shipmentStore">Склад отгрузки</label>
          <v-select v-model="formData.shipmentStore" :options="shipmentStore" id="shipmentStore" name="shipmentStore" class="input-field" placeholder="- Не указан -"></v-select>
        </div>

        <!-- Поле выбора даты отгрузки -->
        <div class="input-group cleared">
            <label class="label-common" for="shipmentDate">Дата отгрузки</label>
            <date-picker 
                v-model="shipmentDate" 
                lang="ru" 
                :format="'DD.MM.YYYY'" 
                placeholder="Выберите дату" 
                input-class="input-field"
            ></date-picker>
        </div>

        
      </div>

      <div class="bk" data-order-section="dimensions">
        <div class="bk-control cleared">
          <div class="red-tl">Габариты и вес</div>
        </div>
        <div class="input-group cleared">
          <label class="label-common" for="weight">Вес</label>
          <input type="text" id="weight" v-model="weight" class="input-field">
        </div>
        <div class="input-group cleared">
          <label class="label-common" for="dimensions">Габариты</label>
          <input type="text" id="length" v-model="length" placeholder="Длина" class="input-field" style="margin-right: 10px;">
          <input type="text" id="width" v-model="width" placeholder="Ширина" class="input-field" style="margin-right: 10px;">
          <input type="text" id="height" v-model="height" placeholder="Высота" class="input-field">
        </div>
      </div>

      <!-- Поля для адреса доставки -->
      <div class="bk" data-order-section="delivery">
        <div class="bk-control cleared">
          <div class="red-tl">Адрес доставки</div>
        </div>
        <!-- Поля доставки -->
        <div class="input-group cleared">
          <label class="label-common" for="deliveryTypes">Тип доставки</label>
          <v-select v-model="formData.deliveryTypes" :options="deliveryTypes" id="deliveryTypes" name="deliveryTypes" class="input-field" placeholder="- Не указан -"></v-select>
        
        </div>

        <!-- Регион -->
        <div class="input-group cleared">
          <label class="label-common" for="deliveryAddressRegion">Регион</label>
          <v-select
            v-if="regions.length"
            v-model="formData.deliveryregion"
            id="deliveryAddressRegion"
            @input="onRegionSelect"
            :options="regions"
            placeholder="- Укажите регион -"
          ></v-select>
        </div>


    <!-- Город -->
    <div class="input-group cleared">
      <label class="label-common" for="deliveryAddressCity">Город</label>
    <!-- Поле ввода для городов с динамической подгрузкой -->
<v-select
  id="deliveryAddressCity"
  v-model="formData.deliverycity"
  :options="cities"
  :disabled="!formData.deliveryregion"
  @input="onCitySelect"
  @search="fetchCities"
  placeholder="- Укажите город -"
></v-select>


    </div>

    <!-- Улица -->
    <div class="input-group cleared">
      <label class="label-common" for="deliveryAddressStreet">Улица</label>
     <!-- Поле ввода для улиц с динамической подгрузкой -->
<v-select
  id="deliveryAddressStreet"
  v-model="formData.deliverystreet"
  :options="streets"
  :disabled="!formData.deliverycity"
  @search="fetchStreets"
  placeholder="- Укажите улицу -"
></v-select>

    </div>

        <div class="input-group cleared">
          <label class="label-common" for="deliveryCost">Стоимость доставки</label>
          <input type="text" id="deliveryCost" v-model="deliveryCost" class="input-field">
        </div>
        <div class="input-group cleared">
          <label class="label-common" for="deliveryAddress">Адрес</label>
          <textarea id="deliveryAddress" v-model="deliveryAddress" class="input-field"></textarea>
        </div>
        <div class="input-group cleared">






          <label class="label-common" for="deliveryDate">Дата доставки</label>
          <date-picker 
                v-model="deliveryDate" 
                lang="ru" 
                :format="'DD.MM.YYYY'" 
                placeholder="Выберите дату" 
                input-class="input-field"
                :disabled-date="disabledVozimDeliveryDate"
                @input="onDeliveryDateInput"
            ></date-picker>
        </div>
        
         <div class="input-group cleared" id="time-group">
            <label class="label-common" for="delivery-time-from">Время доставки</label>

            <div class="gray-bg fs13 time-interval-widget">
              <span class="inputs">
                <span class="exact" v-if="isExactMode">
                  в
                </span>
                <span class="range" v-if="isRangeMode">
                  с
                </span>
                <span class="exact range" v-if="isRangeMode">
                  <input
                    type="text"
                    v-model="timeFrom"
                    v-mask="'##:##'"
                    id="delivery-time-from"
                    placeholder="чч:мм"
                    class="range short center"
                    
                  />
                </span>
                <span class="range" v-if="isRangeMode">
                  по
                  <input
                    type="text"
                    v-model="timeTo"
                    v-mask="'##:##'"
                    id="delivery-time-to"
                    placeholder="чч:мм"
                    class="range short center"
                   
                  />
                </span>
                <span class="custom" v-if="isCustomMode">
                  <input
                    type="text"
                    v-model="customTime"
                    id="delivery-time-custom"
                    placeholder="Введите своё время"
                    class="big left"
                    @input="updateTime"
                  />
                </span>
              </span>

              <span class="select-time-btn dropdown no-set down" @click="toggleDropdown">
                <a href="#">...</a>
                <ul v-if="dropdownVisible">
                  <li v-for="(range, index) in timeRanges" :key="index">
                    <a class="range" href="#" @click.prevent="selectRange(range)">
                      {{ range.label }}
                    </a>
                  </li>
                  <li>
                    <a class="custom-range" href="#" @click.prevent="activateCustomRange">
                      другой диапазон
                    </a>
                  </li>
                  <li>
                    <a class="custom-value" href="#" @click.prevent="activateCustomValue">
                      другое
                    </a>
                  </li>
                  <li>
                    <a class="clear" href="#" @click.prevent="clearTime">
                      очистить
                    </a>
                  </li>
                </ul>
              </span>
            </div>
          </div>




      </div>
    </div>

  </div>




 <div id="order-payment" class="collapse-section template-block" data-template-block-code="payment">
    <!-- Заголовок секции -->
    <div class="collapse-section__head">
      <div class="collapse-section__title">Оплата</div>
      <div class="collapse-section__head-col">
        <div class="collapse-section__head-content"></div>
        <div class="section-error">
          <div class="section-error__icon">
            <svg class="svg-icon">
              <use xlink:href="/build/icons.f8cd2060.svg#error_outlined"></use>
            </svg>
          </div>
          <div class="section-error__text section-error__text_usual">Ошибка в блоке</div>
          <div class="section-error__text section-error__text_require">Не заполнено обязательное поле</div>
        </div>
        <div class="collapse-section__btn" @click="togglePaymentSection">
          <svg class="svg-icon">
            <use :xlink:href="paymentSectionExpanded ? '/build/icons.f8cd2060.svg#chevron_up' : '/build/icons.f8cd2060.svg#chevron_down'"></use>
          </svg>
        </div>
      </div>
    </div>

    <!-- Содержимое секции -->
    <div v-if="paymentSectionExpanded" class="collapse-section__body">
      <div class="bk" data-order-section="payments">
        <div class="cleared info_pay_block">
          <!-- Поле "Номер реестра" -->
          <div class="input-group cleared">
            <label class="label-common" for="registryNumber">Номер реестра</label>
            <input type="text" id="registryNumber" v-model="formData.registryNumber" class="input-field">
          </div>

          <!-- Чекбокс "Отгрузка без оплаты" -->
          <div class="input-group cleared">
            <label class="label-common" for="shipmentWithoutPayment">Отгрузка без оплаты</label>
            <input type="checkbox" id="shipmentWithoutPayment" v-model="formData.shipmentWithoutPayment" class="input-field" value="1">
          </div>

          
          <!-- Итоговая сумма -->
          <div class="input-group cleared">
            <label class="label-common">К оплате</label>
            <div id="order-to-pay-summ" class="gray-bg fs13 static">
              {{ grandTotal.toLocaleString() }}&nbsp;<span class="currency-symbol byn">руб.</span>
            </div>
          </div>
        </div>

        <!-- Список платежей -->
        <div id="payments" class="cleared">
          <div v-for="(payment, index) in payments" :key="index" class="payment">
            <div class="divider-title">
              <span class="controls">{{ payment.name }}</span>
            </div>
            <div class="field-for-group cleared">
              <div class="payment__content-wrapper">
                <!-- Удаление платежа -->
                <a href="#" title="Удалить оплату" @click.prevent="removePayment(index,payment.id)" class="tr-delete"></a>

                <!-- Статус платежа -->
                  <div class="input-group cleared">
                    <label class="label-common">Статус</label>
                    <select v-model="payment.status" class="input-field">
                      <option v-for="status in getPaymentStatuses(payment.type)" :key="status" :value="status">
                        {{ formatStatusLabel(status) }}
                      </option>
                    </select>
                  </div>

                <!-- Дата платежа -->
                  <div class="input-group cleared">
                    <label class="label-common">Дата оплаты</label>
                    <date-picker v-model="payment.date" lang="ru" :format="'DD.MM.YYYY'" input-class="input-field"></date-picker>
                  </div>

                <!-- Сумма платежа -->
                <div class="input-group cleared">
                    <label class="label-common">Сумма</label>
                    <input 
                      type="number" 
                      v-model.number="payment.amount" 
                      @input="updatePaymentAmounts(index, payment.amount)" 
                      class="input-field" 
                      min="0"
                    />
                  </div>

                <!-- Комментарий -->
                <div class="input-group cleared">
                  <a href="javascript:void(0);" class="show-next-block-link link-inline controls" @click="toggleComment(payment)">Добавить комментарий</a>
                </div>
                <div v-if="payment.showComment" class="input-group cleared">
                  <label class="label-common">Комментарий</label>
                  <textarea v-model="payment.comment" class="input-field"></textarea>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Кнопка "Добавить оплату" -->
        <div class="bk__footer bk__footer_dark">
          <div class="controls dropdown no-set add-payment-type">
            <a href="#" @click.prevent="toggleDropdownPay">
              <span>Добавить оплату</span>
            </a>
            <div class="ul-scroll-dropdown-wrapper" :style="{ display: dropdownOpen ? 'block' : 'none' }">
              <ul class="dropdown-with-hints">
                <li v-for="(paymentType, index) in paymentTypes" :key="index" :data-type-id="paymentType.id">
                  <a href="#" @click.prevent="addPayment(paymentType)">
                    {{ paymentType.label }}
                  </a>
                  <div v-if="paymentType.tooltip" class="dropdown-with-hints__hint">
                    <svg class="dropdown-with-hints__hint-icon">
                      <use xlink:href="/build/icons.f8cd2060.svg#error_outlined"></use>
                    </svg>
                    <span class="dropdown-with-hints__tooltip">
                      <p v-for="(text, idx) in paymentType.tooltip" :key="idx" class="dropdown-with-hints__tooltip-text">{{ text }}</p>
                    </span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>




</div>



<div class="m-box__right-side order-compos">
    <!-- Комментарии клиента -->
    <div class="template-block" data-template-block-code="customer-comment">
      <div id="order-customer-comment" class="collapse-section collapse-section_min">
        <div class="collapse-section__head">
          <div class="collapse-section__title">Комментарии клиента</div>
          
        </div>
        <div class="collapse-section__body" >
            <div class="bk">
          <div class="m-box-content" data-order-section="customer-comment">
            <textarea v-model="customerComment" class="input-field wide"></textarea>
          </div>
      </div>
        </div>
      </div>
    </div>

    <!-- Комментарии оператора -->
    <div class="template-block" data-template-block-code="manager-comment">
      <div id="order-manager-comment" class="collapse-section collapse-section_min">
        <div class="collapse-section__head">
          <div class="collapse-section__title">Комментарии оператора</div>
          
        </div>
        <div class="collapse-section__body" >
            <div class="bk">
          <div class="m-box-content" data-order-section="manager-comment">
            <textarea v-model="managerComment" class="input-field wide"></textarea>
          </div>
      </div>
        </div>
      </div>
    </div>
  </div>
 </div>

<div class="save-box save-box_with-btns" data-js-save-box="">
    <div class="wrapper">
      <!-- Блок кнопок -->
      <div class="btn__block btn-split">
        <button
          class="white small btn-save-back btn_split-hov btn"
          @click="createOrderExit"
        >
          Сохранить и выйти
        </button>
        <button
          type="submit"
          name="save"
          class="btn_success small btn-save btn"
          @click="createOrder"
        >
          <div class="btn-content btn-content_icon btn-content_done">
            Сохранить
          </div>
        </button>
      </div>

      <input type="hidden" name="saveAndBack" v-model="saveAndBack" />

      
      

      <div class="save-box__nav"></div>
    </div>





  </div>


    </div>

 <!-- Модальное окно -->

<div class="modal car-selector" v-if="isCarSelectorVisible">
  <div class="modal-content">
    <button class="close-button" @click="closeCarSelector">X</button>
    <car-selector ref="carSelector" @update-link="updateCorpus"></car-selector>
  </div>
</div>



<ProductModal
  :isVisible="isModalVisible"
  :products="products"
  :isProductInOrder="isProductInOrder"
  @add-product="addOrUpdateProduct"
  @increase-product="increaseProductQuantity"
  @decrease-product="decreaseProductQuantity"
  @close="closeModal"
  @remove-product="removeProduct"
/>

<AnalogModal
  :isVisible="isAnalogModalVisible"
  :products="products"
  :isProductInOrder="isProductInOrder"
  :korpusType="selectedKorpusType" 
  @add-product="addOrUpdateProduct"
  @increase-product="increaseProductQuantity"
  @decrease-product="decreaseProductQuantity"
  @close="closeModal"
  @remove-product="removeProduct"
/>



<LoaderTable v-if="loading"/>
</div>


</template>

<script>
import { ORDERS_API_BASE } from '@/config/api';
import axios from 'axios';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import Vue from 'vue';
import { VueMaskDirective } from 'v-mask';

Vue.directive('mask', VueMaskDirective);
import LoaderTable from '@/components/LoaderTable.vue';
import CarSelector from '@/components/CarSelector.vue';
import ProductModal from '@/components/ProductModal.vue';
import AnalogModal from '@/components/AnalogModal.vue';
import { mapState, mapActions } from 'vuex';
import { sortManagersByLabel } from '@/constants/sortManagers';

export default {

  name: 'OrderCreate',
  components: {
   CarSelector,
    LoaderTable,
    AnalogModal,
    ProductModal,
    'v-select': vSelect,
    'date-picker': DatePicker // Зарегистрируйте DatePicker
  },
  data() {
    return {
      paymentSectionExpanded: true,
      dropdownOpen: false,
      timeFrom: '',
            timeTo: '',
            isCarSelectorVisible: false, 
            customTime: '',
            maskTime: '##:##', // Маска для времени
      isRangeMode: true,
      isExactMode: false,
      isCustomMode: false,
      selectedKorpusType: null, // будет хранить тип корпуса для аналогичных товаров
      dropdownVisible: false,
      timeRanges: [
        { from: "09:00", to: "11:30", label: "с 09:00 до 11:30" },
        { from: "11:30", to: "14:00", label: "с 11:30 до 14:00" },
        { from: "14:00", to: "16:30", label: "с 14:00 до 16:30" },
        { from: "16:30", to: "19:00", label: "с 16:30 до 19:00" },
        { from: "19:00", to: "21:30", label: "с 19:00 до 21:30" },
        { from: "21:30", to: "00:00", label: "с 21:30 до 00:00" },
      ],



    oneTimeDiscountAmount: 0,
        oneTimeDiscountPercent: 0,
       loading: false, // Управляет видимостью лоадера
      sectionExpanded: false,
      customerSectionExpanded: false,
      isModalVisible: false,
      priceDropdownVisible: false,
        dropdownPosition: { top: '0px', left: '0px' },
        selectedProduct: null,
        priceInput: 0,
        discountAmount: 0,
        discountPercent: 0,
      availableProducts: [], // доступные товары в модальном окне
       apiKey: 'BAdmMau5GdJ1g9xiHFHVm2KL9WM0NhlX',  // Ваш API-ключ
      regions: [],
      cities: [],
      isAnalogModalVisible:false,
      streets: [],
       contragentTypes: [
        {
          label: 'Физическое лицо',
          value: 'individual'
        },
        {
          label: 'Юридическое лицо',
          value: 'legal-entity'
        },
        {
          label: 'Индивидуальный предприниматель',
          value: 'enterpreneur'
        }
      ],
      formData: {
        registryNumber: "",
        shipmentWithoutPayment: false,
        deliveryregion: null,
        deliverycity: null,
        contragentTypes: null,
        deliverystreet: null,
        country: null,
        tradeInAmount: 0,
        orderType: null,
        manager: null,
        site: null,
        shipmentStore: null,
        orderMethod: null,
        seller: null,
        deliveryTypes: null,
        lastName: '',
        firstName: '',
        email: '',
        phone: '',
        patronymic: ''
      },
      payments: [
        {
          type: "cash",
          name: "1. Наличные",
          status: "not-paid", // Статус по умолчанию
          date: null,
          amount: 0,
          showComment: false,
          comment: "",
        },
      ],
      paymentTypes: [],
      shipmentStore: [],
      saveAndBack: "",
      shipmentDate: null,
      invoiceDate: null,
      deliveryType: '',
      deliveryCost: '',
      customerComment: '',
      managerComment: 'Неправильный номер',
      weight: '',
      length: '',
      width: '',
      height: '',
      deliveryAddress: '',
      deliveryDate: '',
      seller: [],
      stores: [
        { value: '8', text: 'Склад "Карвата"' },
        { value: '7', text: 'ул. Ваупшасова 10' },
      ],
      deliveryTypes: [],
      productSectionExpanded: true,
      errors: {
                orderType: null,
                site: null,
                contragentTypes: null,
                firstName: null
            },
     
      error: false,
      isFieldFilled: true,
      countries: [
        { label: 'Беларусь', value: 'BY' },
        { label: 'Россия', value: 'RU' },
        { label: 'Украина', value: 'UA' }
      ],
      orderTypes: [],
      managers: [],
      sites: [],
      orderMethods: []
    };
  },
  computed: {
  ...mapState({
    products: state => state.products,
  }),
  // Общая стоимость товаров без скидок
totalPrice() {
    return this.products.reduce((sum, product) => sum + (product.originalPrice * product.quantity), 0);
},


totalDiscount() {
    

    const oneTimeDiscountAmount = Number(this.oneTimeDiscountAmount) || 0;
    const oneTimeDiscountPercent = Number(this.oneTimeDiscountPercent) || 0;

    // Считаем общую сумму скидок по каждому товару
    const productDiscounts = this.products.reduce((sum, product) => {
        const discountInRubles = Number(product.discountAmount || 0);
        const discountInPercent = (product.originalPrice * (Number(product.discountPercent || 0) / 100));
        const totalDiscountForProduct = (discountInRubles + discountInPercent) * product.quantity;
        return sum + totalDiscountForProduct;
    }, 0);

    // Общая сумма товаров с учетом всех индивидуальных скидок
    const adjustedTotalPrice = this.products.reduce((sum, product) => {
        return sum + (product.displayPrice * product.quantity);
    }, 0);

    // Считаем разовую скидку от суммы с учетом индивидуальных скидок
    let oneTimeDiscount = 0;
    if (oneTimeDiscountPercent) {
        oneTimeDiscount += (adjustedTotalPrice * oneTimeDiscountPercent) / 100;
    }
    oneTimeDiscount += oneTimeDiscountAmount;

    // Итоговая сумма скидок
    return Math.round(productDiscounts + oneTimeDiscount).toLocaleString("ru-RU");
}




,


  grandTotal() {
    return Math.max(0, this.totalPrice - this.totalDiscount + Number(this.deliveryCost));
  },
  isVozimDeliveryType() {
    const code = this.formData && this.formData.deliveryTypes
      && (this.formData.deliveryTypes.value || this.formData.deliveryTypes);
    return code === 'vozimby' || code === 'rb';
  }
},

            
            methods: {

  getVozimMinDeliveryDate() {
    const min = new Date();
    min.setHours(0, 0, 0, 0);
    return min;
  },
  normalizeDeliveryDateValue(value) {
    if (value == null || value === '') return null;
    const d = value instanceof Date ? new Date(value.getTime()) : new Date(value);
    if (isNaN(d.getTime())) return null;
    d.setHours(0, 0, 0, 0);
    return d;
  },
  disabledVozimDeliveryDate(date) {
    if (!this.isVozimDeliveryType) return false;
    const d = this.normalizeDeliveryDateValue(date);
    if (!d) return false;
    return d < this.getVozimMinDeliveryDate();
  },
  onDeliveryDateInput(value) {
    if (!this.isVozimDeliveryType) return;
    const d = this.normalizeDeliveryDateValue(value);
    const min = this.getVozimMinDeliveryDate();
    if (d && d < min) {
      this.deliveryDate = min;
    }
  },
  validateVozimDeliveryDate() {
    if (!this.isVozimDeliveryType) return true;
    const min = this.getVozimMinDeliveryDate();
    const d = this.normalizeDeliveryDateValue(this.deliveryDate);
    if (!d || d < min) {
      this.deliveryDate = min;
      if (this.$toast) {
        this.$toast.error('Для vozim.by / экспресс vozim.by дата доставки не раньше сегодняшнего дня.', {
          timeout: 5000,
          position: 'bottom-right'
        });
      } else {
        alert('Для vozim.by / экспресс vozim.by дата доставки не раньше сегодняшнего дня.');
      }
      return false;
    }
    return true;
  },

// Инициализация платежей
  initializeDefaultPayments() {
    if (this.payments.length === 1) {
      this.payments[0].amount = this.grandTotal;
    }
  },

  // Обновление сумм в платежах
updatePaymentAmounts(index, newAmount) {
    // Ограничиваем сумму для текущего платежа
    this.payments[index].amount = Math.min(newAmount, this.grandTotal);

    // Рассчитываем общий остаток
    const totalAllocated = this.payments.reduce((sum, payment) => sum + payment.amount, 0);
    let remainingAmount = this.grandTotal - totalAllocated;

    // Если остаток больше нуля, перераспределяем сумму между остальными платежами
    if (remainingAmount > 0) {
        for (let i = 0; i < this.payments.length; i++) {
            if (i === index) continue; // Пропускаем текущий платеж
            // Рассчитываем, сколько еще можно добавить к текущему платежу
            const maxPossibleAddition = Math.min(remainingAmount, this.grandTotal - this.payments[i].amount);
            this.payments[i].amount += maxPossibleAddition;
            remainingAmount -= maxPossibleAddition;

            if (remainingAmount <= 0) break; // Если остаток исчерпан, прекращаем перераспределение
        }
    } 
    // Если остаток отрицательный, перераспределяем сумму между другими платежами
    else if (remainingAmount < 0) {
        remainingAmount = Math.abs(remainingAmount);
        // Сокращаем суммы других платежей, начиная с последнего
        for (let i = this.payments.length - 1; i >= 0; i--) {
            if (i === index) continue; // Пропускаем текущий платеж
            const deduction = Math.min(this.payments[i].amount, remainingAmount);
            this.payments[i].amount -= deduction;
            remainingAmount -= deduction;

            if (remainingAmount <= 0) break;
        }
    }
}
,

  // Пропорциональное распределение сумм по способам оплаты
  rebalancePaymentsProportionally() {
    const totalAssigned = this.payments.reduce((sum, payment) => sum + payment.amount, 0);

    // Если ранее не было суммы, просто распределяем всю сумму на первый способ
    if (totalAssigned === 0) {
      this.payments.forEach((payment, index) => {
        payment.amount = index === 0 ? this.grandTotal : 0;
      });
      return;
    }

    // Распределяем пропорционально текущим значениям
    this.payments.forEach((payment) => {
      payment.amount = Math.round((payment.amount / totalAssigned) * this.grandTotal);
    });
  },

  // Добавление способа оплаты
  addPayment(paymentType) {
    this.payments.push({
      type: paymentType.value,
      name:paymentType.label,
      status: "not-paid", // Статус по умолчанию
      date: null,
      amount: 0,
      showComment: false,
      comment: "",
    });
    this.dropdownOpen = false;
    this.rebalancePaymentsProportionally();
  },

  // Удаление способа оплаты
  removePayment(index,paymentId) {
    this.payments.splice(index, 1);
    this.deletePayment(paymentId);
    this.rebalancePaymentsProportionally();
  },

  // Обновление `grandTotal`
  onGrandTotalChange() {
    this.rebalancePaymentsProportionally();
  },


async createPayment(paymentData) {
  const requestData = {
    action: "create",
    payment: paymentData, // Платёжные данные
  };

  try {
    const response = await axios.post(
      ORDERS_API_BASE + "/paymentOrder.php",
      requestData
    );
    if (response.data.success) {
      this.$toast.success("Платёж успешно добавлен");
      // Обновление данных, если требуется
      this.fetchPayments();
    } else {
      this.$toast.error(`Ошибка: ${response.data.message}`);
    }
  } catch (error) {
    console.error("Ошибка при добавлении платежа:", error);
    this.$toast.error("Произошла ошибка связи с сервером");
  }
},

async editPayment(paymentId, updatedPaymentData) {
  const requestData = {
    action: "edit",
    paymentId: paymentId, // ID платежа, который нужно обновить
    payment: updatedPaymentData, // Новые данные платежа
  };

  try {
    const response = await axios.post(
      ORDERS_API_BASE + "/paymentOrder.php",
      requestData
    );
    if (response.data.success) {
      this.$toast.success("Платёж успешно обновлён");
      // Обновление данных, если требуется
      this.fetchPayments();
    } else {
      this.$toast.error(`Ошибка: ${response.data.message}`);
    }
  } catch (error) {
    console.error("Ошибка при редактировании платежа:", error);
    this.$toast.error("Произошла ошибка связи с сервером");
  }
},

async deletePayment(paymentId) {
  const requestData = {
    action: "delete",
    paymentId: paymentId, // ID платежа, который нужно удалить
  };

  try {
    const response = await axios.post(
      ORDERS_API_BASE + "/paymentOrder.php",
      requestData
    );
    if (response.data.success) {
      this.$toast.success("Платёж успешно удалён");
      // Обновление данных, если требуется
      this.fetchPayments();
    } else {
      this.$toast.error(`Ошибка: ${response.data.message}`);
    }
  } catch (error) {
    console.error("Ошибка при удалении платежа:", error);
    this.$toast.error("Произошла ошибка связи с сервером");
  }
},


    togglePaymentSection() {
      this.paymentSectionExpanded = !this.paymentSectionExpanded;
    },
    calculateTotalToPay() {
      return 1000; // Пример итоговой суммы (замените на нужное значение)
    },
    toggleDropdownPay() {
      this.dropdownOpen = !this.dropdownOpen;
    },
   
    toggleComment(payment) {
      payment.showComment = !payment.showComment;
    },
            updateCorpus(url) {
    this.formData.selectionLink = url; // Обновляем ссылку в форме
    this.closeCarSelector();          // Закрываем модальное окно
  },
  closeCarSelector() {
    this.isCarSelectorVisible = false; // Закрываем модальное окно
  },
  openCarSelector() {
    this.isCarSelectorVisible = true; // Открываем модальное окно
  },
async makeCall() {
  if (!this.formData.phone || !this.$store.state.user.phone_extension) {
    console.error("Не указан номер телефона или внутренний номер пользователя.");
    return;
  }

  const internalNumber = this.$store.state.user.phone_extension;

  // Удаляем все символы, кроме цифр
  let phoneNumber = this.formData.phone.replace(/\D/g, '');

  // Преобразование номера, если он начинается с 8029 или других кодов
  if (phoneNumber.startsWith('80')) {
    phoneNumber = '375' + phoneNumber.slice(2);
  }

  if (!phoneNumber) {
    console.error("Некорректный номер телефона:", this.formData.phone);
    return;
  }

  // clientId (secret) — только для инициации звонков через makecallexternal
  const clientId = "e16bc4fc51d243ae80ab476c51b1e7c2";
  const url = `https://bot.vochi.by/api/makecallexternal?code=${encodeURIComponent(internalNumber)}&phone=${encodeURIComponent('+' + phoneNumber)}&clientId=${clientId}`;

  try {
    const response = await axios.get(url);

    if (response.data && response.data.success === false) {
      console.error("Ошибка при инициации звонка:", response.data.message || response.data);
    } else {
      console.log("Звонок успешно инициирован:", (response.data && response.data.message) || response.data);
    }
  } catch (error) {
    console.error("Ошибка при обращении к API Vochi:", error);
  }
}


,

   toggleDropdown(event) {
        event.preventDefault(); // Предотвращает скролл страницы
        this.dropdownVisible = !this.dropdownVisible;

        // Если открываем выпадающий список, добавляем обработчик клика вне компонента
        if (this.dropdownVisible) {
            document.addEventListener("click", this.handleOutsideClick);
        } else {
            document.removeEventListener("click", this.handleOutsideClick);
        }
    },
    selectRange(range) {
        this.timeFrom = range.from;
        this.timeTo = range.to;
        this.isRangeMode = true;
        this.isCustomMode = false;
        this.dropdownVisible = false;
        document.removeEventListener("click", this.handleOutsideClick);
    },
    activateCustomRange() {
        this.isRangeMode = true;
        this.isExactMode = false;
        this.isCustomMode = false;
        this.timeFrom = "";
        this.timeTo = "";
        this.dropdownVisible = false;
        document.removeEventListener("click", this.handleOutsideClick);
    },
    activateCustomValue() {
        this.isRangeMode = false;
        this.isExactMode = false;
        this.isCustomMode = true;
        this.customTime = "";
        this.dropdownVisible = false;
        document.removeEventListener("click", this.handleOutsideClick);
    },
    updateTime() {
        if (this.isCustomMode) {
            console.log(`Custom time set to: ${this.customTime}`);
        } else {
            console.log(`Time from ${this.timeFrom} to ${this.timeTo}`);
        }
    },
    clearTime() {
        this.timeFrom = "";
        this.timeTo = "";
        this.customTime = "";
        this.isRangeMode = true;
        this.isCustomMode = false;
        this.dropdownVisible = false;
        document.removeEventListener("click", this.handleOutsideClick);
    },
    handleOutsideClick(event) {
        // Проверяем, находится ли клик вне области выпадающего списка
        const dropdown = this.$el.querySelector(".select-time-btn");
        if (dropdown && !dropdown.contains(event.target)) {
            this.dropdownVisible = false;
            document.removeEventListener("click", this.handleOutsideClick);
        }
    },




    updateTotalDiscount() {
    
  },
            // Запрос на получение регионов с фильтрацией по Беларуси
    fetchRegions() {
      axios.get(`https://geohelper.info/api/v1/regions`, {
        params: {
          apiKey: this.apiKey,
          'locale[lang]': 'ru',
          'filter[countryIso]': 'BY'  // Фильтрация по стране Беларусь
        }
      })
      .then(response => {
        if (response.data.success) {
          // Сохраняем регионы Беларуси, используем имя из "localizedNames" или "name"
          this.regions = response.data.result.map(region => ({
            label: region.name,  // Используем локализованное имя, если оно доступно
            value: region.id
          }));
        } else {
          console.error('Ошибка API:', response.data.error.message);
        }
      })
      .catch(error => {
        console.error("Ошибка загрузки регионов:", error);
      });
    },

    // Запрос на получение городов при выборе региона
    onRegionSelect(selectedRegion) {
     

      axios.get(`https://geohelper.info/api/v1/cities`, {
        params: {
          apiKey: this.apiKey,
          'locale[lang]': 'ru',
          'filter[countryIso]': 'BY',  // Фильтрация по стране Беларусь
          'filter[regionId]': selectedRegion.value  // Фильтрация по стране Беларусь
          
        }
      })
      .then(response => {
        if (response.data.success) {
          this.cities = response.data.result.map(city => ({
            label: `${city.localityType.localizedNamesShort.ru} ${city.name}`,
            value: city.id
          }));
        } else {
          console.error('Ошибка API:', response.data.error.message);
        }
      })
      .catch(error => {
        console.error("Ошибка загрузки городов:", error);
      });
    },

    // Запрос на получение улиц при выборе города
    onCitySelect(selectedCity) {
     

      axios.get(`https://geohelper.info/api/v1/streets`, {
        params: {
          apiKey: this.apiKey,
          'locale[lang]': 'ru',
          'filter[cityId]': selectedCity.value
        }
      })
      .then(response => {
        if (response.data.success) {
          this.streets = response.data.result.map(street => ({
            label: `${street.localityType.localizedNamesShort.ru} ${street.name}`,
            value: street.id
          }));
        } else {
          console.error('Ошибка API:', response.data.error.message);
        }
      })
      .catch(error => {
        console.error("Ошибка загрузки улиц:", error);
      });
    },
    // Запрос на получение городов при вводе части названия
fetchCities(query) {
  if (!this.formData.deliveryregion) return;

  axios.get(`https://geohelper.info/api/v1/cities`, {
    params: {
      apiKey: this.apiKey,
      'locale[lang]': 'ru',
      'filter[countryIso]': 'BY',
      'filter[regionId]': this.formData.deliveryregion.value,
      'filter[name]': query || '',  // Поиск по части имени города
      'pagination[limit]': 20
    }
  })
  .then(response => {
    if (response.data.success) {
      this.cities = response.data.result.map(city => ({
       label: `${city.localityType.localizedNamesShort.ru} ${city.name}`,
        value: city.id
      }));
    } else {
      console.error('Ошибка API:', response.data.error.message);
    }
  })
  .catch(error => {
    console.error("Ошибка загрузки городов:", error);
  });
},
// Запрос на получение улиц при вводе части названия
fetchStreets(query) {
  if (!this.formData.deliverycity) return;

  axios.get(`https://geohelper.info/api/v1/streets`, {
    params: {
      apiKey: this.apiKey,
      'locale[lang]': 'ru',
      'filter[cityId]': this.formData.deliverycity.value,
      'filter[name]': query || '',  // Поиск по части имени улицы
      'pagination[limit]': 20
    }
  })
  .then(response => {
    if (response.data.success) {
      this.streets = response.data.result.map(street => ({
        label: `${street.localityType.localizedNamesShort.ru} ${street.name}`,
        value: street.id
      }));
    } else {
      console.error('Ошибка API:', response.data.error.message);
    }
  })
  .catch(error => {
    console.error("Ошибка загрузки улиц:", error);
  });
},
            resetFormData() {
   this.formData = {
     country: null,
     orderType: null,
     manager: null,
     site: null,
     shipmentStore: null,
     orderMethod: null,
     seller: null,
     deliveryTypes: null,
     lastName: '',
     firstName: '',
     email: '',
     phone: '',
     patronymic: '',
     additionalPhone: '',
     email2: '',
     selectionLink: '',
     contragentTypes: null,
     tradeInAmount: '',
     invoiceDate: null,
     batteryCapacity: '',
     discountCard: false,
     managerComments: '',
     wrongSelection: false,
     deliveryregion: null,
     deliverycity: null,
     deliverystreet: null
   };
   this.products = [];
   this.customerComment = '';
   this.managerComment = '';
   this.shipmentDate = null;
   this.deliveryCost = '';
   this.deliveryAddress = '';
   this.deliveryDate = '';
   this.weight = '';
   this.length = '';
   this.width = '';
   this.height = '';
   this.timeFrom = '';
   this.timeTo = '';
   this.customTime = '';
   this.oneTimeDiscountAmount = '';
   this.oneTimeDiscountPercent = '';
}
,
   loadFormData(formId) {
   const savedForms = JSON.parse(localStorage.getItem('savedForms')) || [];
   const savedForm = savedForms.find(form => form.id === formId);

   if (savedForm) {
     this.formData = savedForm.data;
     this.formData.invoiceDate = savedForm.data.invoiceDate ? new Date(savedForm.data.invoiceDate) : null;
     // Преобразуем orderMethod в объект с label и value
        if (typeof savedForm.orderMethod === 'string') {
            const matchedMethod = this.orderMethods.find(
                method => method.value === savedForm.orderMethod || method.label === savedForm.orderMethod
            );
            this.formData.orderMethod = matchedMethod || { label: savedForm.orderMethod, value: savedForm.orderMethod };
        } else {
            this.formData.orderMethod = savedForm.orderMethod;
        }
     this.products = savedForm.products;
     this.customerComment = savedForm.comments.customerComment;
     this.managerComment = savedForm.comments.managerComment;
     this.shipmentDate = savedForm.shipment.shipmentDate ? new Date(savedForm.shipment.shipmentDate) : null;
     this.deliveryCost = savedForm.shipment.deliveryCost;
     this.deliveryAddress = savedForm.shipment.deliveryAddress;
     this.deliveryDate = savedForm.shipment.deliveryDate ? new Date(savedForm.shipment.deliveryDate) : null;
     this.weight = savedForm.shipment.weight;
     this.length = savedForm.shipment.dimensions.length;
     this.width = savedForm.shipment.dimensions.width;
     this.height = savedForm.shipment.dimensions.height;
     this.timeFrom = savedForm.deliveryTime ? savedForm.deliveryTime.from : '';
     this.timeTo = savedForm.deliveryTime ? savedForm.deliveryTime.to : '';
     this.customTime = savedForm.customTime || '';
     this.oneTimeDiscountAmount = savedForm.oneTimeDiscountAmount || '';
     this.oneTimeDiscountPercent = savedForm.oneTimeDiscountPercent || '';

     this.formData.id = savedForm.id;
   }
}

,

calculateProductTotal(product) {
    // Начальная стоимость продукта (цена умноженная на количество)
    let total = product.originalPrice * product.quantity;

    // Применяем процентную скидку
    if (product.discountPercent) {
        total -= (total * product.discountPercent) / 100;
    }

    // Применяем скидку в рублях
    if (product.discountAmount) {
        total -= product.discountAmount * product.quantity;
    }

    // Устанавливаем значение total, гарантируя, что оно не будет отрицательным
    product.total = Math.max(total, 0);
}
,
     ...mapActions({
      // Подключение экшенов из модуля savedFormsModule
      loadSavedForms: "savedFormsModule/loadSavedForms",
      saveForm: "savedFormsModule/saveForm",
      deleteForm: "savedFormsModule/deleteForm",

      
    }),

    deleteForm() {
  const formId = this.formData.id || localStorage.getItem('currentFormId');

  this.$store.dispatch('savedFormsModule/deleteForm', formId)
    .then(() => {
      localStorage.removeItem('currentFormId');
      this.$store.commit('clearProducts'); // Очистка продуктов через Vuex мутацию
      this.$router.push('/');
    })
    .catch(error => console.error('Ошибка при удалении формы:', error));
},

  saveFormAndCollapse() {
  let formId = this.formData.id;

  if (!formId) {
    formId = this.generateUniqueId();
    this.formData.id = formId;
  }

  const formData = {
    id: formId,
    data: {
      ...this.formData,
      invoiceDate: this.formData.invoiceDate
        ? this.formData.invoiceDate.toISOString()
        : new Date().toISOString(), // Устанавливаем текущую дату по умолчанию
    },
    orderMethod: this.formData.orderMethod
      ? { label: this.formData.orderMethod.label, value: this.formData.orderMethod.value }
      : null, // Сохраняем объект с полями label и value
    products: this.products,
    comments: {
      customerComment: this.customerComment,
      managerComment: this.managerComment,
    },
    shipment: {
      shipmentDate: this.shipmentDate ? this.shipmentDate.toISOString() : null,
      deliveryCost: this.deliveryCost,
      deliveryAddress: this.deliveryAddress,
      deliveryDate: this.deliveryDate ? this.deliveryDate.toISOString() : null,
      weight: this.weight,
      dimensions: {
        length: this.length,
        width: this.width,
        height: this.height,
      },
    },
    deliveryTime: {
      from: this.timeFrom,
      to: this.timeTo,
    },
    customTime: this.customTime,
    oneTimeDiscountAmount: this.oneTimeDiscountAmount,
    oneTimeDiscountPercent: this.oneTimeDiscountPercent,
  };

  this.$store.dispatch('savedFormsModule/saveForm', formData)
    .then(() => {
      localStorage.setItem('currentFormId', formData.id);
      this.$router.push('/');
    })
    .catch(error => console.error('Ошибка при сохранении формы:', error));
},


    generateUniqueId() {
      return Math.floor(Date.now() / 1000);
    },
            async createOrderExit() {
    if (!this.validateVozimDeliveryDate()) {
      return;
    }
    const orderData = {
        order: {
            orderType: this.formData.orderType,
            orderMethod: this.formData.orderMethod,
            site: this.formData.site,
            discount:this.oneTimeDiscountAmount,
            discountPercent:this.oneTimeDiscountPercent,
            managerId: this.formData.manager,
            shipmentStore: this.formData.shipmentStore,
            customer: {
                firstName: this.formData.firstName,
                lastName: this.formData.lastName,
                patronymic: this.formData.patronymic,
                phone: this.formData.phone,
                additionalPhone: this.formData.additionalPhone,
                email: this.formData.email
            },
            items: this.products.map(product => ({
                offer: {
                    id: product.id
                },
                discountAmount:product.discountAmount,
                percentAmount:product.discountPercent,
                productName: product.name,
                initialPrice: product.price,
                quantity: product.quantity
            })),
            shipmentDate: this.shipmentDate ? this.shipmentDate.toISOString().split('T')[0] : null,
            delivery: {
                code: this.formData.deliveryTypes,
                cost: this.deliveryCost,
                date: this.deliveryDate ? this.deliveryDate.toISOString().split('T')[0] : null,
                address: {
                    text: this.deliveryAddress,
                    region: this.formData.deliveryregion,
                    city: this.formData.deliverycity,
                    street: this.formData.deliverystreet
                },
                time: {
                    from: this.timeFrom,
                    to: this.timeTo,
                    custom: this.customTime
                },
                weight: this.weight,
                dimensions: {
                    length: this.length,
                    width: this.width,
                    height: this.height
                }
            },
            contragent: {
                contragentType: this.formData.contragentTypes
            },
            managerComment: this.managerComment,
            customerComment: this.customerComment,
            customFields: {
                invoiceDate: this.formData.invoiceDate ? this.formData.invoiceDate.toISOString().split('T')[0] : null,
                email2: this.formData.email2,
                dfgfdddf:this.formData.tradeInAmount,
                komentariimenedgera: this.formData.managerComments,
                sssylkaaaaasssyyylka: this.formData.selectionLink,
                slksdkk2j3iu3n: this.formData.batteryCapacity,
                wrongSelection: this.formData.wrongSelection ? 'yes' : 'no',
                prodavec: this.formData.seller // Добавлено поле seller в customFields
            }
        }
    };

    try {
        const response = await axios.post(ORDERS_API_BASE + '/createOrder.php', orderData);
        if (response.data.success) {
            this.$router.push('/orders');
            alert('Заказ успешно создан!');
        } else {
            alert('Ошибка при создании заказа: ' + response.data.message);
        }
    } catch (error) {
        console.error('Ошибка при создании заказа:', error);
        alert('Произошла ошибка при создании заказа.');
    }
},

 handleBeforeUnload() {
      
     
        this.$store.dispatch('savedFormsModule/clearSavedForms');
        this.$store.commit('clearProducts');
        console.log('хуйня ебаная сработала');
      
    },
validateField(fieldName) {
            // Если поле заполнено, удаляем ошибку
            if (this.formData[fieldName]) {
                this.errors[fieldName] = null ;
            }
        },
           async createOrder() {
                    this.loading = true; // Устанавливаем загрузку
                this.clearErrors(); // Сбрасываем ошибки перед началом проверки

                // Проверка полей
                if (!this.formData.orderType) {
                    this.errors.orderType = 'Обязательное поле';
                }
                if (!this.formData.site) {
                    this.errors.site = 'Обязательное поле';
                }
                if (!this.formData.contragentTypes) {
                    this.errors.contragentTypes = 'Обязательное поле';
                }
                if (!this.formData.firstName) {
                    this.errors.firstName = 'Обязательное поле';
                }

                // Если есть ошибки, прекратить выполнение

                if (Object.values(this.errors).some(error => error)) {
                    setTimeout(() => {
                        this.loading = false; // Сбрасываем загрузку после небольшой задержки
                    }, 500); // Таймаут 500 мс (можно изменить)
                    return;
                }

                if (!this.validateVozimDeliveryDate()) {
                    this.loading = false;
                    return;
                }


                    // Формируем данные платежей
                 const payments = this.payments.map(payment => ({
                    externalId: null, // Внешний ID, если есть
                    amount: payment.amount,
                    paidAt: payment.date ? new Date(payment.date).toISOString().split('T')[1].slice(0, 5) : null, // Преобразуем в H:i
                    comment: payment.comment || "",
                    type: payment.type,
                    status: payment.status || null,
                }));


                    const orderData = {
                        order: {
                            orderType: this.formData.orderType,
                            orderMethod: this.formData.orderMethod,
                            site: this.formData.site,
                            discount: this.oneTimeDiscountAmount,
                            discountPercent: this.oneTimeDiscountPercent,
                            managerId: this.formData.manager,
                            shipmentStore: this.formData.shipmentStore,
                            customer: {
                                firstName: this.formData.firstName,
                                lastName: this.formData.lastName,
                                patronymic: this.formData.patronymic,
                                phone: this.formData.phone,
                                additionalPhone: this.formData.additionalPhone,
                                email: this.formData.email,
                            },
                            items: this.products.map(product => ({
                                offer: {
                                    id: product.id,
                                },
                                discountAmount: product.discountAmount,
                                percentAmount: product.discountPercent,
                                productName: product.name,
                                initialPrice: product.price,
                                quantity: product.quantity,
                            })),
                            payments, // Добавляем платежи
                            shipmentDate: this.shipmentDate ? this.shipmentDate.toISOString().split('T')[0] : null,
                            delivery: {
                                code: this.formData.deliveryTypes,
                                cost: this.deliveryCost,
                                date: this.deliveryDate ? this.deliveryDate.toISOString().split('T')[0] : null,
                                address: {
                                    text: this.deliveryAddress,
                                    region: this.formData.deliveryregion,
                                    city: this.formData.deliverycity,
                                    street: this.formData.deliverystreet,
                                },
                                time: {
                                    from: this.timeFrom,
                                    to: this.timeTo,
                                    custom: this.customTime,
                                },
                                weight: this.weight,
                                dimensions: {
                                    length: this.length,
                                    width: this.width,
                                    height: this.height,
                                },
                            },
                            contragent: {
                                contragentType: this.formData.contragentTypes,
                            },
                            managerComment: this.managerComment,
                            customerComment: this.customerComment,
                            customFields: {
                                invoiceDate: this.formData.invoiceDate ? this.formData.invoiceDate.toISOString().split('T')[0] : null,
                                email2: this.formData.email2,
                                dfgfdddf: this.formData.tradeInAmount,
                                komentariimenedgera: this.formData.managerComments,
                                sssylkaaaaasssyyylka: this.formData.selectionLink,
                                slksdkk2j3iu3n: this.formData.batteryCapacity,
                                wrongSelection: this.formData.wrongSelection ? 'yes' : 'no',
                                prodavec: this.formData.seller, // Добавлено поле seller в customFields
                            },
                        },
                    };

                    try {
                        const response = await axios.post(ORDERS_API_BASE + '/createOrder.php', orderData);
                        if (response.data.success) {
                            const { orderId, orderSite, orderCreated } = response.data;
                            

                            const formData = { id:orderId, idorder:orderId, site: this.formData.site , created:orderCreated, phone: this.formData.phone, orderMethod:this.formData.orderMethod};
                            this.loading = false;
                            alert('Заказ успешно создан!');
                            this.saveForm(formData);
                            this.$router.push({ name: 'OrderEdit', params: { orderId, site: orderSite } });
                        } else {
                            this.loading = false;
                            alert('Ошибка при создании заказа: ' + response.data.message);
                        }
                    } catch (error) {
                        console.error('Ошибка при создании заказа:', error);
                        alert('Произошла ошибка при создании заказа.');
                        this.loading = false;
                    }
                },

                clearErrors() {
                    this.errors = {
                        orderType: null,
                        site: null,
                        contragentTypes: null,
                        firstName: null
                    };
                },
                // Открытие модального окна и начало загрузки данных
                openAnalogModal(product) {

                  console.log(product.korpus); 
                  this.selectedKorpusType = product.korpus; 

                  this.isAnalogModalVisible = true; // открываем модальное окно
                  

                },
                // Открытие модального окна и начало загрузки данных
                openModal() {
                  this.isModalVisible = true;
                  

                  // Выполняем AJAX запрос на получение товаров
                  axios
                    .get(ORDERS_API_BASE + '/modalproduct.php')
                    .then(response => {
                      this.availableProducts = response.data;
                      this.loading = false;
                    })
                    .catch(error => {
                      console.error('Ошибка при загрузке товаров:', error);
                      this.loading = false;
                    });
                },
                // Закрытие модального окна
                closeModal() {
                  this.isModalVisible = false;
                  this.isAnalogModalVisible = false;
                },
                // Метод для добавления или обновления количества товара
addOrUpdateProduct(product, quantity = 1) {
    const existingProduct = this.$store.state.products.find(p => p.id === product.id);
    if (existingProduct) {
        this.$store.commit('updateProductQuantity', { productId: product.id, quantity });
    } else {
        this.$store.commit('addProduct', { 
            ...product, 
            quantity, 
            originalPrice: product.price,
            displayPrice: product.price,
            total: product.price * quantity 
        });
    }
},
calculateDiscountedPrice(product) {
    let discountedPrice = product.originalPrice;

    // Применение скидки в процентах и рублях
    if (product.discountPercent) {
        discountedPrice -= (product.originalPrice * product.discountPercent) / 100;
    }
    if (product.discountAmount) {
        discountedPrice -= product.discountAmount;
    }

    return Math.max(discountedPrice, 0);
},

   // Функция для удаления товара из заказа
  removeProduct(productId) {
    this.$store.commit('removeProduct', productId);
  },

     // Метод для увеличения количества
    increaseProductQuantity(productId) {
        const existingProduct = this.$store.state.products.find(p => p.id === productId);
        if (existingProduct) {
            const newQuantity = existingProduct.quantity + 1;
            this.$store.commit('updateProductQuantity', { productId, quantity: newQuantity });
        }
    },

    // Метод для уменьшения количества
    decreaseProductQuantity(productId) {
        const existingProduct = this.$store.state.products.find(p => p.id === productId);
        if (existingProduct) {
            if (existingProduct.quantity > 1) {
                const newQuantity = existingProduct.quantity - 1;
                this.$store.commit('updateProductQuantity', { productId, quantity: newQuantity });
            } else {
                // Если количество становится 1 и уменьшается, удаляем товар из Vuex
                this.$store.commit('removeProduct', productId);
            }
        }
    },

               isProductInOrder(productId) {
    return this.products.find(product => product.id === productId) || null;
}
,
               decreaseQuantity(product) {
    if (product.quantity > 1) {
        product.quantity--;
        this.updateProductTotal(product);
    }
},
increaseQuantity(product) {
    product.quantity++;
    this.updateProductTotal(product);
},
updateQuantity(product) {
    if (product.quantity < 1) {
        product.quantity = 1;
    }
    this.updateProductTotal(product);
},
updateProductTotal(product) {
    // Используйте displayPrice, которая учитывает скидку
    product.total = product.displayPrice * product.quantity;
},
                  toggleProduct(product) {
                    const index = this.products.findIndex(p => p.id === product.id);
                    if (index === -1) {
                      this.products.push({
                        ...product,
                        quantity: 1,
                        total: product.price,
                      });
                    } else {
                      this.products.splice(index, 1);
                    }
                  },
                  updateProductQuantity(productId, quantity) {
                    const product = this.products.find(p => p.id === productId);
                    if (product) {
                      product.quantity = quantity;
                      product.total = product.price * quantity;
                    }
                  },

                  openPriceDropdown(product) {
    this.selectedProduct = product;
    
    // Сохраняем оригинальную цену при первом открытии
    if (product.originalPrice === undefined) {
        product.originalPrice = product.price;
    }

    this.priceInput = product.price;
    this.discountAmount = product.discountAmount || 0;  // Загружаем сохранённую скидку в рублях
    this.discountPercent = product.discountPercent || 0; // Загружаем сохранённую скидку в процентах

    const row = event.currentTarget.getBoundingClientRect();
    this.dropdownPosition = { top: `${row.top + window.scrollY}px`, left: `${row.left + window.scrollX}px` };
    this.priceDropdownVisible = true;
},
closePriceDropdown() {
    this.priceDropdownVisible = false;
    this.selectedProduct = null;
},
applyPriceChange() {
    if (this.selectedProduct) {


        console.log(this.selectedProduct);


        // Устанавливаем новую цену товара
        this.selectedProduct.originalPrice = this.priceInput;
        this.selectedProduct.price= this.priceInput;

        // Считаем скидки и устанавливаем итоговую цену
        this.selectedProduct.discountAmount = this.discountAmount;
        this.selectedProduct.discountPercent = this.discountPercent;
        this.selectedProduct.displayPrice = this.calculateDiscountedPrice(this.selectedProduct);

        // Пересчитываем итоговую стоимость товара
        this.updateProductTotal(this.selectedProduct);

        // Закрываем выпадающее меню
        this.closePriceDropdown();

        // Обновляем массив товаров, чтобы Vue отследил изменения
        this.products = [...this.products];
    }
},


                
                // Метод для получения списка менеджеров
                // Метод для получения списка менеджеров
                fetchManagers() {
                  axios.get(ORDERS_API_BASE + '/manager.php')
                    .then(response => {
                      this.managers = sortManagersByLabel(response.data);
                      this.setDefaultManager(); // Установить менеджера после загрузки списка

                    })
                    .catch(error => {
                      console.error('Ошибка при получении менеджеров:', error);
                    });
                },
                // Метод для установки менеджера по умолчанию на основе залогиненного пользователя
                setDefaultManager() {
                  let user = null;

                  // Проверяем Vuex для текущего пользователя
                  if (this.$store.state.user) {
                    user = this.$store.state.user;
                  } 
                  // Если в Vuex нет, проверяем localStorage
                  else if (localStorage.getItem('user')) {
                    user = JSON.parse(localStorage.getItem('user'));
                  }

                  // Установим менеджера по умолчанию, если текущий пользователь есть в списке менеджеров
                  if (user) {
                    const matchedManager = this.managers.find(manager => manager.value === user.id);
                    if (matchedManager) {
                      this.formData.manager = matchedManager;

                    }
                  }
                },
                fetchStores() {
                    axios.get(ORDERS_API_BASE + '/store.php')
                        .then(response => {
                            this.sites = response.data;
                            this.$nextTick(() => {
                              if (!this.formData.site) {
                                this.formData.site = this.sites.find(type => type.value === '1akb-by');
                              }
                            });
                        })
                        .catch(error => {
                            console.error('Ошибка при получении магазинов:', error);
                        });
                },
                fetchOrderMethods() {
                    axios.get(ORDERS_API_BASE + '/sposob.php')
                        .then(response => {
                            this.orderMethods = response.data;
                        })
                        .catch(error => {
                            console.error('Ошибка при получении способов оформления:', error);
                        });
                },
                fetchSeller() {
                    axios.get(ORDERS_API_BASE + '/seller.php')
                        .then(response => {
                            this.seller = response.data;
                        })
                        .catch(error => {
                            console.error('Ошибка при получении способов оформления:', error);
                        });
                },
                fetchShipmentStore() {
                    axios.get(ORDERS_API_BASE + '/sklad.php')
                        .then(response => {
                            this.shipmentStore = response.data;
                        })
                        .catch(error => {
                            console.error('Ошибка при получении способов оформления:', error);
                        });
                },
                fetchPayment() {
                    axios.get(ORDERS_API_BASE + '/payment.php')
                      .then(response => {
                        this.paymentTypes = response.data.paymentTypes;
                      })
                      .catch(error => {
                        console.error('Ошибка при получении способов оформления:', error);
                      });
                  },
                  getPaymentStatuses(paymentType) {
                      // Найти объект типа оплаты по value
                      const selectedType = this.paymentTypes.find(type => type.value === paymentType);
                      // Вернуть список статусов, если объект найден, иначе пустой массив
                      return selectedType && selectedType.paymentStatuses ? selectedType.paymentStatuses : [];
                    },
                  formatStatusLabel(status) {
                    const labels = {
                      'not-paid': 'Не оплачен',
                      'invoice': 'Выставлен счет',
                      'payment-start': 'Начало оплаты',
                      'paid': 'Оплачен',
                      'fail': 'Ошибка',
                      'credit-approved': 'Кредит одобрен',
                      'credit-check': 'Проверка кредита',
                    };
                    return labels[status] || status;
                  },
                fetchOrderTypes() {
                    axios.get(ORDERS_API_BASE + '/ordertype.php')
                      .then(response => {
                        // Если данные имеют другую структуру, преобразуем их
                        this.orderTypes = response.data.map(item => ({
                          label: item.label || item.name, // Предполагаем, что API может возвращать `name` вместо `label`
                          value: item.value || item.id   // Предполагаем, что API может возвращать `id` вместо `value`
                        }));

                        this.$nextTick(() => {
                          // Устанавливаем значение по умолчанию только после обновления orderTypes
                          if (!this.formData.orderType) {
                            this.formData.orderType = this.orderTypes.find(type => type.value === 'eshop-individual');
                          }
                        });
                      })
                      .catch(error => {
                        console.error('Ошибка при получении способов оформления:', error);
                      });
                  },
                fetchDeliveryTypes() {
                    axios.get(ORDERS_API_BASE + '/delivery.php')
                        .then(response => {
                            this.deliveryTypes = response.data;
                        })
                        .catch(error => {
                            console.error('Ошибка при получении способов оформления:', error);
                        });
                },
                setDefaultContragentType() {
                    setTimeout(() => {
                    this.formData.contragentTypes = { label: 'Физическое лицо', value: 'individual' };
                    },200);
                },
                toggleSection() {
                    this.sectionExpanded = !this.sectionExpanded;
                },
                toggleCustomerSection() {
                    this.customerSectionExpanded = !this.customerSectionExpanded;
                },
                saveAndExit() {
                  this.saveAndBack = true;
                  this.createOrder();
                  console.log("Сохранить и выйти");
                },
                save() {
                  this.saveAndBack = false;
                  this.createOrder();
                  console.log("Сохранить");
                },
                deleteOrder() {
                  // Логика удаления заказа
                  const confirmDeletion = confirm(
                    "Восстановить заказ можно в течение 14 дней, после этого срока восстановление невозможно. Удалить заказ?"
                  );
                  if (confirmDeletion) {
                    window.location.href = "/orders/580430/delete";
                  }
                },
            },
            watch: {

                grandTotal(newTotal, oldTotal) {
    if (newTotal !== oldTotal) {
      const totalAllocated = this.payments.reduce((sum, payment) => sum + payment.amount, 0);

      if (totalAllocated !== newTotal) {
        const remainingAmount = newTotal - totalAllocated;

        // Распределяем оставшуюся сумму
        if (remainingAmount > 0) {
          this.payments[0].amount += remainingAmount;
        } else {
          let excess = Math.abs(remainingAmount);
          this.payments.forEach(payment => {
            const deduction = Math.min(payment.amount, excess);
            payment.amount -= deduction;
            excess -= deduction;
          });
        }
      }
    }
  },
  
                // Отслеживаем изменения в tradeInAmount и обновляем oneTimeDiscountAmount
                'formData.tradeInAmount': function (newTradeInAmount) {
                    this.oneTimeDiscountAmount = Number(newTradeInAmount) || 0;
                    this.updateTotalDiscount(); // Пересчитываем общую скидку при изменении
                }
            },
            beforeRouteLeave(to, from, next) {
    this.handleBeforeUnload();
    next();
  },

            mounted() {
                // Устанавливаем тип контрагента по умолчанию
               
               this.initializeDefaultPayments();
                console.log(this.products.id);
                this.fetchManagers();
                this.fetchStores();
                this.fetchPayment();
                this.fetchOrderMethods();
                this.fetchSeller();
                this.fetchShipmentStore();
                this.fetchOrderTypes();
                this.fetchDeliveryTypes();
                this.fetchRegions();
                console.log(this.$options.directives);
                this.setDefaultContragentType();
                const formId = this.$route.params.formId;
                if (formId) {
                  this.loadFormData(formId);
                } else {
                  this.resetFormData();
                }
  }

            };
</script>

<style scoped>
.order-head {


}

.order-head__flex {
    align-items: flex-end;
    display: flex;
}

.order-head>div {
    color: #1e2248;
    font-size: 12px;
        width: 100%;
}


.order-num {
    font-size: 24px;
    font-weight: 500;
}


.order-num, .order-num span {
    color: #1e2248;
}

.mx-datepicker {
    position: relative;
    display: inline-block;
    width: 212px;
}

.mx-icon-calendar, .mx-icon-clear {
    position: absolute;
    top: 16px!important;
    right: -10px;
    -webkit-transform: translateY(-50%);
    transform: translateY(-42%);
    font-size: 16px;
    line-height: 1;
    color: rgba(0, 0, 0, .5);
    vertical-align: middle;
}
.btn.white {
    margin-right: 10px;
    
}

.loader-overlay{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

.order-table-footer {
    display: flex;
    padding: 0 24px;
    border-top: solid 0px #dee2e6;
}

.order-empty {
    padding: 10px;
}

.order-table-footer__left, .order-table-footer__right {
    padding: 24px 0;
}

.order-table-footer__right {
    border-left: 1px solid #dee2e6;
    padding-left: 72px;
}

.m-box.order-products-table-box .patch-target {
    transition: .3s;
}




.order-table-footer__list {
    list-style: none;
    padding: 0;
}

.order-table-footer__list_info {
    min-width: 240px;
}

.order-table-footer__list:not(:last-child) {
    margin-bottom: 14px;
}

.order-table-footer__total {
    color: #1e2248;
    font-size: 18px;
    font-weight: 500;
    line-height: 1.55555556;
    text-align: right;
}



.order-table-footer__list-item {
    align-items: center;
    display: flex;
}


.order-table-footer__list-item:not(:last-child) {
    margin-bottom: 8px;
}



.order-table-footer__text_full {
    flex-grow: 1;
}

.order-table-footer__text_muted {
    color: #636f7f;
    font-size: 12px;
    font-weight: 400;
    line-height: 1.16666667;
    text-align: right;
}



.order-table-footer__text {
    color: #0d0f1f;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.42857143;
}

.order-table-footer__text_charge, .order-table-footer__text_price, .order-table-footer__text_writeoff {
    min-width: 74px;
    text-align: right;
}

.order-table-footer__text+.order-table-footer__text {
    margin-left: 16px;
}

p {
    margin:0px;
}

.header-main {
    display: table;
    empty-cells: hide;
    padding: 32px 0 24px;
    width: 100%;
}



.header-main .hm-left {
    width: auto;
}

.header-main .hm-left, .header-main .hm-right {
    display: table-cell;
    float: none;
    vertical-align: top;
}



.header-main .hm-left, .header-main .hm-right {
    display: table-cell;
    float: none;
    vertical-align: top;
}

.header-main .hm-right{
    white-space: nowrap;
    width: 1%;
}

.btn-close-order {
    background: none;
    background-color: #fff;
    background-image: linear-gradient(180deg, #fff, #e9ecee);
    border: 1px solid #dee2e6;
    border-radius: 6px;
    cursor: pointer;
    display: inline-block;
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, Roboto, sans-serif;
    font-size: 14px;
    font-size: 0;
    font-weight: 400;
    height: 21px;
    line-height: 20px;
    line-height: 17px;
    overflow: hidden;
    padding: 8px;
    position: relative;
    text-decoration: none;
    text-overflow: ellipsis;
    text-shadow: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
    vertical-align: middle;
    white-space: nowrap;
    width: 21px;
}

.btn-close-order:before {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24'%3E%3Cpath fill='%23FF5353' d='M7.113 6.176a.6.6 0 0 1 .848 0L12 10.214l4.038-4.038a.6.6 0 0 1 .849 0l.937.937a.6.6 0 0 1 0 .848L13.785 12l4.04 4.04a.6.6 0 0 1 0 .848l-.937.937a.6.6 0 0 1-.849 0L12 13.784l-4.038 4.04a.6.6 0 0 1-.849 0l-.937-.937a.6.6 0 0 1 0-.848l4.04-4.04-4.039-4.038a.6.6 0 0 1 0-.849l.937-.936Z'/%3E%3C/svg%3E");
    background-position: 50%;
    background-repeat: no-repeat;
    bottom: 0;
    content: "";
    height: 21px;
    left: 0;
    margin: auto;
    position: absolute;
    right: 0;
    top: 0;
    width: 21px;
}

.list-box-two {
        display: flex;
    justify-content: space-between;
}

textarea.input-field {
    display: block;
    font-family: inherit;
    height: 140px!important;
    line-height: 18px;
    padding-top: 5px;
    resize: none;
}










table td {
    empty-cells: show;
}

.modern-table tr td {
    border-bottom: 1px solid #dee2e6;
    color: #1e2248;
    font-size: 12px;
    padding: 8px 5px;
    text-align: right;
    vertical-align: middle;
}
.modern-table tr td.select, .modern-table tr td.title, .modern-table tr th.select, .modern-table tr th.title {
    text-align: left;
}
.modern-table tr:last-child td {
    border-bottom-width: 0;
}

.modern-table.order-products tr td, .modern-table.order-products tr th {
    padding-left: 10px;
    padding-right: 10px;
}

.modern-table.order-products tr td {
    padding: 15px 10px;
    vertical-align: top;
}

.modern-table.order-products tr td.bord, .modern-table.order-products tr th.bord {
    border-right: 1px solid #dee2e6;
}

.modern-table.order-products tr td.title {
    font-size: 13px;
    padding-left: 0;
}

.modern-table.order-products tr:last-child td {
    border-bottom-width: 1px;
}



.qty-btn, .add-btn {
    margin: 0 4px;
    padding: 8px 12px;
    font-size: 12px;
    font-weight: 500;
    border: none;
    cursor: pointer;
    color: #ffffff;
    border-radius: 5px;
    transition: background 0.3s ease;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.qty-btn-increase {
    color: #000000;
    cursor: pointer;
    background-color: #fff;
    background-image: linear-gradient(180deg, #fff, #e9ecee);
    border: 1px solid #dee2e6;
    text-shadow: none;
    box-shadow: none;
}

.qty-btn-decrease {
    color: #000000;
    cursor: pointer;
    background-color: #fff;
    background-image: linear-gradient(180deg, #fff, #e9ecee);
    border: 1px solid #dee2e6;
    text-shadow: none;
    box-shadow: none;
    font-weight: 600;
}

.order-price__dropdown {
    position: absolute;
    background: #fff;
    border: 1px solid #ccc;
    padding: 15px;
    border-radius: 5px;
    z-index: 10;
    width: 300px;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
}

.order-price__caption {
    font-weight: bold;
    margin-bottom: 5px;
}



.order-price__input-wrap {
    display: flex;
    align-items: center;
    gap: 5px;
}

.order-price__controls {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
}

.order-price__input_size_l {
    flex-grow: 1;
}

.order-price__error-wrap {
    min-height: 24px;
}

.order-discount__currency {
    color: #1e2248;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.42857143;
    margin-left: 4px;
}

.order-price__controls_column {
    flex-direction: column;
}

.order-price__caption {
    color: #636f7f;
    font-size: 12px;
    font-weight: 400;
    line-height: 1.16666667;
    margin-bottom: 8px;
}

.order-price__controls {
    display: flex;
    font-style: normal;
    margin-bottom: 0;
}

.order-price__input-wrap {
    align-items: center;
    display: flex;
    position: relative;
}

.order-price__input {
    background-color: #fff;
    border: 1px solid #dee2e6;
    border-radius: 4px;
    border-radius: 6px;
    color: #1e2248;
    font-size: 14px;
    font-weight: 400;
    height: 30px;
    height: 36px;
    line-height: 1.42857143;
    outline: none;
    padding: 0 16px;
    width: 88px;
}

.order-price__button:not(:last-child) {
    margin-right: 16px;
}

.order-price__controls button {
    color: #ffffff;
}

.btn.order-price__cancel {
    background-color: #fff;
    background-image: linear-gradient(180deg, #fff, #e9ecee);
    border: 1px solid #dee2e6;
    text-shadow: none;
    color: black;
}

.order-price__value {
    border-bottom: 1px dotted;
    color: #0052cc;
    display: inline-block;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.42857143;
}

.modern-order-table .value.patch-target, .modern-order-table .value.price__value {
    color: #1e2248;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.42857143;
}

.modern-order-table .subtotal .value.patch-target {
    font-size: 14px;
    font-weight: 500;
    line-height: 1.42857143;
    margin-bottom: 12px;
    position: relative;
    white-space: nowrap;
}



.order-row__title {
    align-items: center;
    color: #636f7f;
    display: inline-flex;
    font-size: 14px;
    font-weight: 500;
    line-height: 1.42857143;
}

.order-row__title:not(:last-child) {
    margin-right: 24px;
}

.order-discount, .order-discount__input-wrap {
    display: flex;
    position: relative;
}



.order-discount, .order-discount__input-wrap {
    display: flex;
    position: relative;
}

.order-discount__input-wrap {
    align-items: center;
}

.order-discount__input {
    background-color: #fff;
    border: 1px solid #dee2e6;
    border-radius: 4px;
    color: #1e2248;
    font-size: 14px;
    font-weight: 400;
    height: 30px;
    line-height: 1.42857143;
    outline: none;
    padding: 0 16px;
    width: 72px;
}

.order-discount__currency {
    color: #1e2248;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.42857143;
    margin-left: 4px;
}

.order-discount__input-wrap+.order-discount__input-wrap {
    margin-left: 16px;
}

.modern-order-table .min-input.quantity {
    border: 1px solid #dee2e6;
    border-radius: 4px;
    box-shadow: none;
    color: #1e2248;
    font-size: 14px!important;
    font-weight: 400;
    height: 30px!important;
    line-height: 1.42857143;
    outline: none;
    padding: 0 8px;
    width: 44px;
    text-align:right;
}

.button_quantity {
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

.inline-tooltip__target.js-subtotal-value {
        font-size: 14px;
    font-weight: 500;
    line-height: 1.42857143;
    margin-bottom: 12px;
    position: relative;
    white-space: nowrap;
}




.order-table-footer__list-item {
    align-items: center;
    display: flex;
}

.order-table-footer__list-item:not(:last-child) {
    margin-bottom: 8px;
}

.order-table-footer__text_full {
    flex-grow: 1;
}





.order-table-footer__text {
    color: #0d0f1f;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.42857143;
}

.order-table-footer__text_charge, .order-table-footer__text_price, .order-table-footer__text_writeoff {
    min-width: 74px;
    text-align: right;
}

.order-table-footer__text+.order-table-footer__text {
    margin-left: 16px;
}


.order-table-footer__total {
    color: #1e2248;
    font-size: 18px;
    font-weight: 500;
    line-height: 1.55555556;
    text-align: right;
}

.order-table-footer__text_muted {
    color: #636f7f;
    font-size: 12px;
    font-weight: 400;
    line-height: 1.16666667;
    text-align: right;
}

.modern-order-table .subtotal .info-btn-group {
    bottom: 15px;
    margin-right: 0;
    margin-top: 0;
    position: absolute;
    right: 15px;
}

.info-btn {
    min-width: 30px;
}

.info-btn, .info-btn__switch {
    display: inline-block;
    height: 30px;
    position: relative;
    vertical-align: top;
    width: 30px;
}

.info-btn__switch {
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: 20px 14px;
    border: 1px solid transparent;
    cursor: pointer;
    margin: 0 !important;
}



.info-btn__switch_trash {
    background-image: url("data:image/svg+xml;charset=US-ASCII,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 11 14%27%3E%3Cg fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 fill=%27%23E6E6E6%27%3E%3Cpath d=%27M1 2h9c.6 0 1 .4 1 1s-.4 1-1 1H1c-.6 0-1-.4-1-1s.4-1 1-1zM3.5 0h4c.3 0 .5.2.5.5s-.2.5-.5.5h-4C3.2 1 3 .8 3 .5s.2-.5.5-.5zM2 5v7c0 1.1.9 2 2 2h3c1.1 0 2-.9 2-2V5H2zm3 6.5c0 .3-.2.5-.5.5s-.5-.2-.5-.5v-4c0-.3.2-.5.5-.5s.5.2.5.5v4zm2 0c0 .3-.2.5-.5.5s-.5-.2-.5-.5v-4c0-.3.2-.5.5-.5s.5.2.5.5v4z%27/%3E%3C/g%3E%3C/svg%3E");
}

.modern-order-table .info-btn__switch_trash {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24'%3E%3Cpath fill='%238A96A6' fill-rule='evenodd' d='M20 5.5v-1a.5.5 0 0 0-.5-.5H15V3a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v1H4.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h15a.5.5 0 0 0 .5-.5Zm-4.662 14.64a1 1 0 0 0 .998-.94L17 8h2l-.85 12.14a2 2 0 0 1-2 1.86H7.87a2 2 0 0 1-2-1.86L5 8h2l.664 11.2a1 1 0 0 0 .998.94h6.676Z' clip-rule='evenodd'/%3E%3C/svg%3E");
    background-size: 16px;
}

.modern-order-table .info-btn__switch_trash:hover:not(.disabled) {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24'%3E%3Cpath fill='%23FF5353' fill-rule='evenodd' d='M20 5.5v-1a.5.5 0 0 0-.5-.5H15V3a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v1H4.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h15a.5.5 0 0 0 .5-.5Zm-4.662 14.64a1 1 0 0 0 .998-.94L17 8h2l-.85 12.14a2 2 0 0 1-2 1.86H7.87a2 2 0 0 1-2-1.86L5 8h2l.664 11.2a1 1 0 0 0 .998.94h6.676Z' clip-rule='evenodd'/%3E%3C/svg%3E");
}

.info-btn__tooltip {
    background-color: #3a3a3a;
    border-radius: 2px;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .15);
    color: #fff !important;
    font-size: 12px;
    left: 50%;
    line-height: 15px;
    margin-left: 0 !important;
    opacity: 0;
    padding: 3px 0;
    position: absolute;
    text-align: center;
    top: calc(100% + 4px);
    transform: translate3d(-50%, 0, 0);
    transition: .15s ease;
    visibility: hidden;
    width: 130px;
    z-index: 100;
}

#app {
    padding-bottom: 150px;
}



.gray-bg, .red-bg {
    background: #f9fafb;
    border-radius: 5px;
    display: inline-block;
    float: left;
    padding: 5px 10px 7px;
}

.m-box .gray-bg {
    background-color: #f4f6f8;
}




.gray-bg input, .red-bg input {
    background: none;
    border: none;
    border-bottom: 1px solid #ccc;
    color: #005eeb;
    display: inline-block;
    font-size: 13px;
    max-width: 72px;
    text-align: right;
}

.gray-bg input.short, .red-bg input.short {
    max-width: 52px;
}

.gray-bg input.center, .red-bg input.center {
    text-align: center;
}


.dropdown, .dropdown_hover {
    display: inline-block;
    position: relative;
}
.select-time-btn {
    float: none;
    margin-left: 5px;
}


.dropdown>a, .kpi-filter .date-selector>a {
    border-bottom-style: dotted;
    border-bottom-width: 1px;
    color: #0052cc;
    text-decoration: none;
}

.select-time-btn>a {
    border-bottom: 1px dotted;
    display: inline-block;
    text-decoration: none;
}




.dropdown .dropdown-wrapper, .dropdown ul, .dropdown_hover .dropdown-wrapper, .dropdown_hover ul {
    background-color: #fff;
    border: 1px solid #d9d9d9;
    border-radius: 2px;
    box-shadow: 0 3px 15px rgba(0, 0, 0, .12);
    
    float: left;
    font-weight: 400;
    left: 0;
    list-style: none;
    margin: 0;
    min-width: 170px;
    opacity: .99;
    padding: 0;
    position: absolute;
    z-index: 1800;
}

.dropdown.down>.dropdown-wrapper, .dropdown.down>.ul-scroll-dropdown-wrapper, .dropdown.down>ul, .dropdown_hover.down>.dropdown-wrapper, .dropdown_hover.down>.ul-scroll-dropdown-wrapper, .dropdown_hover.down>ul {
    margin-top: 6px;
    top: 100%;
}

.select-time-btn.dropdown ul {
    left: -9px;
}

.dropdown .dropdown-wrapper>li, .dropdown ul>li, .dropdown_hover .dropdown-wrapper>li, .dropdown_hover ul>li {
    display: block;
    font-size: 18px;
    line-height: 1.2;
    white-space: nowrap;
}

.dropdown .dropdown-wrapper>li>a, .dropdown ul>li>a, .dropdown_hover .dropdown-wrapper>li>a, .dropdown_hover ul>li>a {
    display: block;
    font-size: 14px;
    line-height: inherit;
    overflow: hidden;
    padding: 9px 20px;
    text-decoration: none;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.dropdown .dropdown-wrapper>li:first-child>a, .dropdown ul>li:first-child>a, .dropdown_hover .dropdown-wrapper>li:first-child>a, .dropdown_hover ul>li:first-child>a {
    border-radius: 2px 2px 0 0;
}





.dropdown .dropdown-wrapper:after, .dropdown .dropdown-wrapper:before, .dropdown .ul-scroll-dropdown-wrapper:after, .dropdown .ul-scroll-dropdown-wrapper:before, .dropdown ul:after, .dropdown ul:before, .dropdown_hover .dropdown-wrapper:after, .dropdown_hover .dropdown-wrapper:before, .dropdown_hover .ul-scroll-dropdown-wrapper:after, .dropdown_hover .ul-scroll-dropdown-wrapper:before, .dropdown_hover ul:after, .dropdown_hover ul:before {
    border-color: transparent;
    border-style: solid;
    content: "";
    display: block;
    height: 0;
    left: 10px;
    position: absolute;
    width: 0;
    z-index: 1;
}
.dropdown .dropdown-wrapper:before, .dropdown .ul-scroll-dropdown-wrapper:before, .dropdown ul:before, .dropdown_hover .dropdown-wrapper:before, .dropdown_hover .ul-scroll-dropdown-wrapper:before, .dropdown_hover ul:before {
    border-bottom-color: #d9d9d9;
    border-width: 0 5.5px 6px;
}

.dropdown .dropdown-wrapper:after, .dropdown .dropdown-wrapper:before, .dropdown .ul-scroll-dropdown-wrapper:after, .dropdown .ul-scroll-dropdown-wrapper:before, .dropdown ul:after, .dropdown ul:before, .dropdown_hover .dropdown-wrapper:after, .dropdown_hover .dropdown-wrapper:before, .dropdown_hover .ul-scroll-dropdown-wrapper:after, .dropdown_hover .ul-scroll-dropdown-wrapper:before, .dropdown_hover ul:after, .dropdown_hover ul:before {
    z-index: 1801;
}

.dropdown.down>.dropdown-wrapper:after, .dropdown.down>.dropdown-wrapper:before, .dropdown.down>.ul-scroll-dropdown-wrapper:after, .dropdown.down>.ul-scroll-dropdown-wrapper:before, .dropdown.down>ul:after, .dropdown.down>ul:before, .dropdown_hover.down>.dropdown-wrapper:after, .dropdown_hover.down>.dropdown-wrapper:before, .dropdown_hover.down>.ul-scroll-dropdown-wrapper:after, .dropdown_hover.down>.ul-scroll-dropdown-wrapper:before, .dropdown_hover.down>ul:after, .dropdown_hover.down>ul:before {
    bottom: 100%;
    top: auto;
}

.input-group .checkbox-list, .input-group .chosen-container, .input-group.courier-group, .input-group .input-field, .input-group .v-select {
    max-width: 463px;
    width: 100%;
    height: 32px;
    border: 1px solid hsla(0, 0%, 48.2%, .25882352941176473) !important;
    border-radius: 4px !important;
}

#wrongSelection {
    width:20px;
}

#discountCard {
    width:20px;
}

.modern-table .acc-tovar {
    background: none;
    background-color: #fff;
    border: 1px solid #dee2e6;
    border-radius: 4px;
    cursor: pointer;
    display: inline-block;
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, Roboto, sans-serif;
    font-size: 12px;
    font-size: 11px;
    font-weight: 400;
    height: 26px;
    line-height: "normal";
    margin-top: 12px;
    padding: 6px 10px 5px;
    text-decoration: none;
    text-shadow: none;
    user-select: none;
    vertical-align: middle;
    white-space: nowrap;
}



.modern-table .acc-tovar, .modern-table .acc-tovar:focus {
    outline: none;
}

.modern-table .acc-tovar, .modern-table .acc-tovar:active, .modern-table .acc-tovar:hover {
    color: #636f7f;
}

.qty-btn:hover {
  opacity:.5;
}

.acc-tovar:hover {
    color: #636f7f;
    background-color: #f6f6f6;
}


.order-products .acc-tovar {
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        display: -webkit-box;
        line-height: 14px;
        max-height: 16px;
        overflow: hidden;
        white-space: normal;
        word-break: break-all;
    }


    .modern-table .acc-tovar:before {
        background-image: url("data:image/svg+xml;charset=US-ASCII,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 10%27%3E%3Cg fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 fill=%27%23B2B2B2%27 %3E%3Cpath d=%27M0 0h8v2H0V0zM0 4h8v2H0V4zM0 8h8v2H0V8z%27/%3E%3C/g%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-size: contain;
        content: "";
        display: inline-block;
        height: 10px;
        margin-right: 5px;
        vertical-align: -1px;
        width: 10px;
    }


.original-price {
    text-decoration: line-through;
    color: #888;
    margin-left: 5px;
}

.input-group .v-select.vs--single.vs--searchable{
    border:solid 0px!important;
}

.sticky-saved-orders {
    display:none;
}

.vs__dropdown-toggle {
    border: 1px solid rgba(60, 60, 60, .26);
}

.call-button {
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' width='512' height='512' style='shape-rendering:geometricPrecision;text-rendering:geometricPrecision;image-rendering:optimizeQuality;fill-rule:evenodd;clip-rule:evenodd'%3e%3cpath fill='%23fefffe' d='M277.5-.5h12c104.845 23.53 175.679 85.864 212.5 187a503.138 503.138 0 0 1 9.5 37v9c-5.458 10.198-13.458 12.698-24 7.5l-3.5-3.5C469.001 156.906 426.834 96.74 357.5 56c-26.136-14.045-53.802-23.712-83-29-9.874-10.441-8.874-19.608 3-27.5Z' style='opacity:.958'/%3e%3cpath fill='%23fefffe' d='M381.5 511.5h-28c-28.815-4.324-56.481-12.824-83-25.5C163.94 433.773 83.44 354.94 29 249.5c-14.802-29.566-24.635-60.566-29.5-93v-26c1.952-13.678 6.785-26.345 14.5-38A545.237 545.237 0 0 1 69.5 37c21.868-12.567 42.534-10.9 62 5a1855.233 1855.233 0 0 1 71.5 73.5c12.766 23.757 9.766 45.423-9 65L160.5 214c12.934 25.7 29.434 48.867 49.5 69.5 24.901 27.093 53.567 49.093 86 66a965.629 965.629 0 0 0 37.5-36.5c23.285-18.265 46.285-17.931 69 1l61.5 61.5c19.631 21.462 21.631 44.462 6 69a1765.816 1765.816 0 0 1-49.5 50.5c-11.803 8.539-24.803 14.039-39 16.5Zm-285-453c4.683.439 9.016 1.939 13 4.5l66.5 66.5c7.154 10.304 6.154 19.971-3 29a1101.106 1101.106 0 0 1-40 39c-4.129 5.699-5.462 12.032-4 19a226.895 226.895 0 0 0 25 47c28.999 39.668 63.833 73.168 104.5 100.5l30 16c9.672 3.236 18.338 1.57 26-5l41-41c8.557-6.189 16.89-5.855 25 1a3173.43 3173.43 0 0 1 66.5 67.5c4.667 7.333 4.667 14.667 0 22a1564.09 1564.09 0 0 1-46.5 47.5c-13.749 8.883-28.749 11.883-45 9a214.824 214.824 0 0 1-55-15C185.258 414.758 101.091 331.925 48 217.5c-10.483-23.434-16.65-47.934-18.5-73.5-.395-13.058 3.105-24.891 10.5-35.5L85.5 63c3.553-2.12 7.22-3.62 11-4.5Z' style='opacity:.959'/%3e%3cpath fill='%23fefffe' d='M277.5 91.5c66.203 12.096 111.203 49.596 135 112.5 4.165 10.819 5.998 21.985 5.5 33.5-4.462 8.479-11.296 11.313-20.5 8.5a25.55 25.55 0 0 1-6.5-5.5c-9.644-50.491-37.478-86.991-83.5-109.5a195.367 195.367 0 0 0-35-10c-11.123-8.204-11.79-17.204-2-27 2.427-.902 4.76-1.736 7-2.5Z' style='opacity:.955'/%3e%3c/svg%3e");
    width: 30px;
    height: 30px;
    position: absolute;
    left: 85px;
    background-repeat: no-repeat;
    background-color: #21b889;
    background-position: center;
    background-size: 70%;
     border-radius: 3px!important;
    display: block;
    right: -13px;
    top: 22px;
    cursor:pointer;
    transition: background-color 0.3s ease, transform 0.2s ease;
}

/* Состояние наведения */
.call-button:hover {
  //background-color: #45a049; /* Более темный зеленый */
  transform: scale(1.05); /* Легкое увеличение */
}

/* Состояние клика */
.call-button:active {
  //background-color: #388e3c; /* Еще темнее */
  transform: scale(0.95); /* Легкое уменьшение */
}


.auto_podbor {
   background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='630' height='630' contentScriptType='text/ecmascript' version='1.0'%3e%3cimage xlink:actuate='onLoad' xlink:href='data:image/png;base64,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' xlink:show='embed' xlink:type='simple' width='472.5' height='472.5' preserveAspectRatio='none' transform='scale(1.33333)'/%3e%3c/svg%3e");
       width: 30px;
    height: 30px;
    position: absolute;
    left: 85px;
    background-repeat: no-repeat;
    background-color: #0d6efd;
    background-position: center;
    background-size: 85%;
     border-radius: 3px!important;
    display: block;
    right: -13px;
    top: 25px;
    cursor: pointer;
    transition: background-color 0.3s ease, transform 0.2s ease;

}

/* Состояние наведения */
.auto_podbor:hover {
  //background-color: #45a049; /* Более темный зеленый */
  transform: scale(1.05); /* Легкое увеличение */
}

/* Состояние клика */
.auto_podbor:active {
  //background-color: #388e3c; /* Еще темнее */
  transform: scale(0.95); /* Легкое уменьшение */
}


.modal {
  display: none; /* По умолчанию скрыто */
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex; /* Центрирование содержимого */
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal.car-selector {
  display: block; /* Включается, когда окно открыто */
}

.modal.car-selector .modal-content {
  background: white;
    padding: 20px;
    border-radius: 8px;
    width: 80%;
    max-width: 600px;
    position: relative;
    max-height: 500px;
    overflow-y: auto;
}

.modal.car-selector .close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  background: transparent;
  border: none;
  font-size: 20px;
  cursor: pointer;
}



.divider-title {
   
    margin: 0 20px 15px;
    position: relative;
    width: calc(100% - 40px);
}

.payment .divider-title {
    margin-bottom: 0;
}


.divider-title:before {
    background: #005eeb;
    content: "";
    display: block;
    height: 1px;
    left: 0;
    position: absolute;
    top: 50%;
    width: 100%;
}

.controls {
    margin-left: 120px;
    position: relative;
}

.divider-title .controls {
    background: #fff;
    color: #005eeb;
    display: inline-block;
    font-size: 10px;
    letter-spacing: 1px;
    line-height: 1.6;
    padding: 0 10px;
    position: relative;
    text-align: center;
    text-transform: uppercase;
    z-index: 1;
}

.bk__footer {
    border-bottom: none;
    font-size: 12px;
    margin: 12px 20px 0 140px;
    padding-bottom: 23px;
    width: 100%;
}

.bk__footer_dark {
    background: #fdfdfd;
    border-top: 1px solid #ebebeb;
    margin: 0;
    padding: 32px 20px;
}

.bk__footer_dark {
    background: #f9fafb;
}

.m-box .bk .bk__footer_dark {
    border-radius: 0 0 4px 4px;
}


.bk__footer:after, .bk__footer:before {
    content: " ";
    display: table;
}

#order-payment .bk {
    padding-bottom: 0px;
}

.controls {
    margin-left: 120px;
    position: relative;
}

.dropdown, .dropdown_hover {
    display: inline-block;
    position: relative;
}




.dropdown>a, .kpi-filter .date-selector>a {
    border-bottom-style: dotted;
    border-bottom-width: 1px;
    color: #0052cc;
    text-decoration: none;
}

.add-payment-type>a, .add-rule-action>a, .add-segment-action>a {
    border-bottom: none;
    display: inline-block;
    padding-left: 24px;
    position: relative;
    text-decoration: none;
}


.add-payment-type>a:before, .add-rule-action>a:before, .add-segment-action>a:before {
    background-image: url("data:image/svg+xml;charset=US-ASCII,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 10 10%27%3E%3Cpath fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 fill=%27%2322C993%27 d=%27M10 4H6V0H4v4H0v2h4v4h2V6h4z%27/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-size: contain;
    bottom: 0;
    content: "";
    display: block;
    height: 10px;
    left: 0;
    margin-bottom: auto;
    margin-left: 4px;
    margin-top: auto;
    position: absolute;
    right: auto;
    top: 0;
    width: 10px;
}

.add-payment-type>a>span, .add-rule-action>a>span, .add-segment-action>a>span {
    border-bottom: 1px dotted;
    color: #005eeb;
}

.dropdown .ul-scroll-dropdown-wrapper, .dropdown_hover .ul-scroll-dropdown-wrapper {
    border-radius: 2px;
    display: none;
    position: absolute;
    z-index: 1800;
}




.dropdown .dropdown-wrapper, .dropdown ul, .dropdown_hover .dropdown-wrapper, .dropdown_hover ul {
    background-color: #fff;
    border: 1px solid #d9d9d9;
    border-radius: 2px;
    box-shadow: 0 3px 15px rgb(0 0 0 / 12%);
    
    float: left;
    font-weight: 400;
    left: 0;
    list-style: none;
    margin: 0;
    min-width: 170px;
    opacity: .99;
    padding: 0;
    position: absolute;
    z-index: 1800;
}
.dropdown-with-hints {
    width: auto;
}

.add-payment-type.dropdown ul {
    max-height: 250px;
    overflow: auto;
}

.dropdown .ul-scroll-dropdown-wrapper>ul, .dropdown_hover .ul-scroll-dropdown-wrapper>ul {
    float: none;
    margin-top: 0;
    position: relative;
}


#shipmentWithoutPayment {
    width: 20px;
}

.info_pay_block  {
    margin-bottom: 20px;
}


.payment__content-wrapper {
    display: inline-block;
    position: relative;
    width: 100%;
}

.tr-delete {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24'%3E%3Cpath fill='%23AFB9C3' fill-rule='evenodd' d='M20 5.5v-1a.5.5 0 0 0-.5-.5H15V3a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v1H4.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h15a.5.5 0 0 0 .5-.5Zm-4.662 14.64a1 1 0 0 0 .998-.94L17 8h2l-.85 12.14a2 2 0 0 1-2 1.86H7.87a2 2 0 0 1-2-1.86L5 8h2l.664 11.2a1 1 0 0 0 .998.94h6.676Z' clip-rule='evenodd'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-size: contain;
    cursor: pointer;
    display: block;
    float: right;
    height: 15px;
    margin: 7px 0 0;
    width: 15px;
}

.payment .tr-delete {
    display: block;
    height: 20px;
    margin: 0;
    position: absolute;
    right: 35px;
    top: 20px;
    width: 20px;
    z-index: 1;
}


.tr-delete:hover {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24'%3E%3Cpath fill='%23FF5353' fill-rule='evenodd' d='M20 5.5v-1a.5.5 0 0 0-.5-.5H15V3a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v1H4.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h15a.5.5 0 0 0 .5-.5Zm-4.662 14.64a1 1 0 0 0 .998-.94L17 8h2l-.85 12.14a2 2 0 0 1-2 1.86H7.87a2 2 0 0 1-2-1.86L5 8h2l.664 11.2a1 1 0 0 0 .998.94h6.676Z' clip-rule='evenodd'/%3E%3C/svg%3E");
    opacity: 1;
}



.dropdown-with-hints li {
    position: relative;
}

.dropdown .dropdown-wrapper>li, .dropdown ul>li, .dropdown_hover .dropdown-wrapper>li, .dropdown_hover ul>li {
    display: block;
    font-size: 18px;
    line-height: 1.2;
    white-space: nowrap;
}



.dropdown .dropdown-wrapper>li>a, .dropdown ul>li>a, .dropdown_hover .dropdown-wrapper>li>a, .dropdown_hover ul>li>a {
    display: block;
    font-size: 14px;
    line-height: inherit;
    overflow: hidden;
    padding: 9px 20px;
    text-decoration: none;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.dropdown .dropdown-wrapper>li:first-child>a, .dropdown ul>li:first-child>a, .dropdown_hover .dropdown-wrapper>li:first-child>a, .dropdown_hover ul>li:first-child>a {
    border-radius: 2px 2px 0 0;
}



.dropdown-with-hints__hint {
    display: none;
}

.dropdown .dropdown-wrapper>li>div, .dropdown ul>li>div, .dropdown_hover .dropdown-wrapper>li>div, .dropdown_hover ul>li>div {
    padding: 0 20px;
}

.dropdown-with-hints__tooltip {
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 8px 16px rgb(30 34 72 / 16%);
    color: #1e2248;
    display: none;
    font-size: 14px;
    font-weight: 400;
    height: 164px;
    line-height: 1.42857143;
    padding: 12px 16px;
    white-space: normal;
    width: 292px;
}


.dropdown .dropdown-wrapper:after, .dropdown .ul-scroll-dropdown-wrapper:after, .dropdown ul:after, .dropdown_hover .dropdown-wrapper:after, .dropdown_hover .ul-scroll-dropdown-wrapper:after, .dropdown_hover ul:after {
    border-bottom-color: #fff;
    border-width: 0 4.5px 5px;
    margin-left: 1px;
}

a {
  font-size: 12px;
  text-decoration: none;
}

.is-invalid {
    border: 2px solid red;
}

.is-valid {
    border: 2px solid green;
}

.error-message {
    color: red;
    font-size: 12px;
    position: absolute;
    right: 5px;
}

.success-message {
    color: #20ac82;
    font-size: 12px;
    position: absolute;
    right: 5px;
}

</style>


<style>

.modal.car-selector .vs__dropdown-toggle {
    min-width: 284px;
}

input::placeholder {
    color: #a9a9a9!important; /* Цвет */
    opacity: 1; /* Убедитесь, что непрозрачность установлена */
}

input::-webkit-input-placeholder { color: #a9a9a9; } /* Chrome, Safari, Edge */
input::-moz-placeholder { color: #a9a9a9; }          /* Firefox 19+ */
input:-ms-input-placeholder { color: #a9a9a9; }      /* Internet Explorer */
input:-moz-placeholder { color: #a9a9a9; }  


</style>
